(function(){
    'use strict';

    /* =========================================================
       CONFIG - UPDATE THIS AFTER DEPLOYING THE WORKER
       ========================================================= */
    var WORKER_URL = 'https://nutriop-staff-email.red-bush-308f.workers.dev';

    /* =========================================================
       COUNTRY -> LOCAL CARRIER MAP
       URL templates use {tracking} placeholder.
       Sorted alphabetically with priority markets pinned on top.
       ========================================================= */
    var COUNTRIES = [
      ['DE','Germany',             'Deutsche Post / DHL',     'https://www.dhl.de/de/privatkunden/pakete-empfangen/verfolgen.html?piececode={tracking}'],
      ['GB','United Kingdom',      'Royal Mail',              'https://www.royalmail.com/track-your-item#/tracking-results/{tracking}'],
      ['US','United States',       'USPS',                    'https://tools.usps.com/go/TrackConfirmAction?tLabels={tracking}'],
      ['AU','Australia',           'Australia Post',          'https://auspost.com.au/mypost/track/details/{tracking}'],
      ['CH','Switzerland',         'Swiss Post',              'https://service.post.ch/EasyTrack/submitParcelData.do?formattedParcelCodes={tracking}'],
      ['',   '- EU & other --',     '',                        ''],
      ['AE','United Arab Emirates','Emirates Post',           'https://www.emiratespost.ae/all-services/track-a-package/step-two?q={tracking}'],
      ['AT','Austria',             'Austrian Post',           'https://www.post.at/en/track?snr={tracking}'],
      ['BE','Belgium',             'bpost',                   'https://track.bpost.cloud/btr/web/#/search?itemCode={tracking}'],
      ['BG','Bulgaria',            'Bulgarian Posts',         'https://www.bgpost.bg/en/track'],
      ['CA','Canada',              'Canada Post',             'https://www.canadapost-postescanada.ca/track-reperage/en#/details/{tracking}'],
      ['CY','Cyprus',              'Cyprus Post',             'https://www.cypruspost.post/en/track'],
      ['CZ','Czechia',             'Czech Post',              'https://www.postaonline.cz/trackandtrace/-/zasilka/cislo?parcelNumbers={tracking}'],
      ['DK','Denmark',             'PostNord',                'https://www.postnord.dk/en/our-tools/track-and-trace?shipmentId={tracking}'],
      ['EE','Estonia',             'Omniva',                  'https://www.omniva.ee/track?barcode={tracking}'],
      ['ES','Spain',               'Correos',                 'https://www.correos.es/es/es/herramientas/localizador/envios/detalle?tracking-number={tracking}'],
      ['FI','Finland',             'Posti',                   'https://www.posti.fi/en/tracking#/lahetys/{tracking}'],
      ['FR','France',              'La Poste',                'https://www.laposte.fr/outils/suivre-vos-envois?code={tracking}'],
      ['GR','Greece',              'Hellenic Post (ELTA)',    'https://www.elta.gr/en-us/personal/find/track-shipment.aspx?queryCode={tracking}'],
      ['HR','Croatia',             'Croatian Post',           'https://posiljka.posta.hr/?BrojPosiljke={tracking}'],
      ['HU','Hungary',             'Magyar Posta',            'https://www.posta.hu/szolgaltatasok/nyomonkovetes?searchValues={tracking}'],
      ['IE','Ireland',             'An Post',                 'https://www.anpost.com/Post-Parcels/Track'],
      ['IL','Israel',              'Israel Post',             'https://mypost.israelpost.co.il/itemtrace?itemcode={tracking}'],
      ['IS','Iceland',             'Iceland Post',            'https://www.posturinn.is/en/track-and-trace/?trackingnumber={tracking}'],
      ['IT','Italy',               'Poste Italiane',          'https://www.poste.it/cerca/index.html#/risultati-spedizioni/{tracking}'],
      ['LI','Liechtenstein',       'Liechtensteinische Post', 'https://service.post.ch/EasyTrack/submitParcelData.do?formattedParcelCodes={tracking}'],
      ['LT','Lithuania',           'Lithuanian Post',         'https://www.post.lt/en/help/parcel-search?ItemCode={tracking}'],
      ['LU','Luxembourg',          'POST Luxembourg',         'https://www.post.lu/en/individuals/track-trace'],
      ['LV','Latvia',              'Latvijas Pasts',          'https://pasts.lv/en/uzzinai/track-and-trace/?id={tracking}'],
      ['MT','Malta',               'MaltaPost',               'https://www.maltapost.com/Tracking'],
      ['NL','Netherlands',         'PostNL',                  'https://jouw.postnl.nl/track-and-trace/{tracking}'],
      ['NO','Norway',              'Posten Norge',            'https://sporing.posten.no/sporing/{tracking}'],
      ['NZ','New Zealand',         'NZ Post',                 'https://www.nzpost.co.nz/tools/tracking?trackid={tracking}'],
      ['PL','Poland',              'Poczta Polska',           'https://emonitoring.poczta-polska.pl/?numer={tracking}'],
      ['PT','Portugal',            'CTT',                     'https://www.ctt.pt/feapl_2/app/open/objectSearch/objectSearch.jspx?objects={tracking}'],
      ['RO','Romania',             'Romanian Post',           'https://www.posta-romana.ro/en/track-trace'],
      ['RS','Serbia',              'Serbian Post',            'https://www.posta.rs/eng/alati/pracenje-posiljke.aspx'],
      ['SE','Sweden',              'PostNord Sweden',         'https://www.postnord.se/en/our-tools/track-and-trace?shipmentId={tracking}'],
      ['SI','Slovenia',            'Slovenian Post',          'https://sledenje.posta.si/?id={tracking}'],
      ['SK','Slovakia',            'Slovak Post',             'https://tandt.posta.sk/en/zasielky?parcelNo={tracking}'],
      ['TW','Taiwan',              'Chunghwa Post',           'https://postserv.post.gov.tw/webpost/sendInfor.do?queryNo={tracking}'],
      ['__','Other (manual)',      '',                        '']
    ];

    var ORIGIN_TRACK = {
      'Swiss Post':    'https://service.post.ch/EasyTrack/submitParcelData.do?formattedParcelCodes={tracking}',
      'Deutsche Post': 'https://www.deutschepost.de/sendung/simpleQuery.html?form.sendungsnummer={tracking}'
    };

    var COURIER_CARRIERS = ['DHL', 'UPS', 'DPD', 'TNT', 'DHL eCommerce'];

    // Postal carriers delivering in their own country: one link, direct-delivery wording (mirrors the Worker registry).
    var DOMESTIC_HOME = { 'Swiss Post': ['CH','LI'], 'Royal Mail': ['GB','IM','JE','GG'], 'Deutsche Post': ['DE'], 'bpost': ['BE'] };
    function isDomestic(carrier, cc){ return !!(DOMESTIC_HOME[carrier] && cc && DOMESTIC_HOME[carrier].indexOf(cc) > -1); }
    function isDirect(carrier, cc){ return isCourier(carrier) || isDomestic(carrier, cc); }
    // Origin link for a postal carrier when the parcel leaves its home country (bpost hands to Landmark Global).
    var INTL_TRACK_TEMPLATES = { 'bpost': 'https://track.landmarkglobal.com/?search={tracking}' };

    // Direct courier tracking templates ({tracking} is the only dynamic part).
    var TRACK_TEMPLATES = {
      'Swiss Post':    'https://service.post.ch/EasyTrack/submitParcelData.do?formattedParcelCodes={tracking}',
      'Deutsche Post': 'https://www.deutschepost.de/sendung/simpleQuery.html?form.sendungsnummer={tracking}',
      'DHL':           'https://www.dhl.de/de/privatkunden/pakete-empfangen/verfolgen.html?piececode={tracking}',
      'UPS':           'https://www.ups.com/track?tracknum={tracking}',
      'DPD':           'https://www.dpdgroup.com/nl/mydpd/my-parcels/incoming?parcelNumber={tracking}',
      'TNT':           'https://www.tnt.com/express/en_gb/site/shipping-tools/tracking.html?searchType=con&cons={tracking}',
      'DHL eCommerce': 'https://my.dhlecommerce.nl/home/tracktrace/{tracking}/{postcode}',
      'Royal Mail':    'https://www.royalmail.com/track-your-item#/tracking-results/{tracking}',
      'bpost':         'https://track.bpost.cloud/btr/web/#/search?itemCode={tracking}'
    };

    function isCourier(carrier){ return COURIER_CARRIERS.indexOf(carrier) > -1; }

    var COUNTRY_NAME_BY_CODE = {};
    var COUNTRY_DATA_BY_CODE = {};
    COUNTRIES.forEach(function(c){
      if(c[0] && c[0] !== '__'){
        COUNTRY_NAME_BY_CODE[c[0]] = c[1];
        COUNTRY_DATA_BY_CODE[c[0]] = { name:c[1], carrier:c[2], url:c[3] };
      }
    });

    /* ============================================================
       TRANSLATIONS - 26 languages with country defaults
       Generated block. Edit by hand only if you know what you're doing.
       ============================================================ */
  var TRANSLATIONS = {
    'en': {
      name_native: 'English',
      subject: 'Your Nutriop Order #{order} Has Been Shipped',
      badge: 'Order Shipped',
      heading: 'Order #{order} has shipped',
      greeting: 'Dear {firstName},',
      thanks: 'Thank you for your order with Nutriop Longevity.',
      shipped_intro: 'We\'re pleased to let you know that your order <strong>#{order}</strong> has now been shipped and is making its way to you.',
      routing: 'Your parcel has been sent via our International Tracked delivery service through <strong>{carrier}</strong> and will be transferred to your local postal carrier in <strong>{country}</strong> for final delivery.',
      routing_courier: 'Your order is being delivered directly to your address in <strong>{country}</strong> by <strong>{carrier}</strong>. You can follow its journey at any time using the tracking link below.',
      tracking_note_courier: 'Tracking details usually appear shortly after dispatch and update at each stage as {carrier} brings your parcel to you. Occasionally the very first scan can take a little time to show online.',
      dpd_note: 'Please note: for DPD shipments, you may need to copy and re-enter the tracking number on the DPD tracking page to view the latest updates.',
      tracking_label: 'Tracking Number',
      follow_label: 'Follow your shipment:',
      tracking_suffix: 'tracking',
      delay_1: 'Please keep in mind that international tracking updates are not always immediate. It can sometimes take a short period for the first physical scans and transit events to appear online, particularly while the parcel is moving between countries.',
      delay_2: 'Once your shipment arrives in your country and enters the local postal network, tracking information will normally update more regularly.',
      closing_thanks: 'We truly appreciate your patience and trust, and we\'ll keep our fingers crossed for a smooth and speedy delivery.',
      closing_help: 'If you need any assistance, we\'re always here to help, simply reply to this email.',
      sign_off: 'Kind regards,',
      team: 'Customer Care Team',
      tel_label: 'Tel:',
      rtl: false
    },
    'de': {
      name_native: 'Deutsch',
      subject: 'Ihre Nutriop-Bestellung #{order} wurde versandt',
      badge: 'Bestellung versandt',
      heading: 'Ihre Bestellung #{order} wurde versandt',
      greeting: 'Hallo {firstName},',
      thanks: 'Vielen Dank für Ihre Bestellung bei Nutriop Longevity.',
      shipped_intro: 'Wir freuen uns, Ihnen mitteilen zu können, dass Ihre Bestellung <strong>#{order}</strong> soeben versandt wurde und nun auf dem Weg zu Ihnen ist.',
      routing: 'Ihr Paket wurde über unseren nachverfolgbaren, internationalen Versandservice mit <strong>{carrier}</strong> verschickt und wird für die finale Zustellung an Ihren lokalen Postdienstleister in <strong>{country}</strong> übergeben.',
      routing_courier: 'Ihre Bestellung wird direkt an Ihre Adresse in <strong>{country}</strong> durch <strong>{carrier}</strong> zugestellt. Sie können die Sendung jederzeit über den untenstehenden Tracking-Link verfolgen.',
      tracking_note_courier: 'Die Tracking-Informationen erscheinen in der Regel kurz nach dem Versand und werden bei jedem Schritt aktualisiert, während {carrier} Ihr Paket zu Ihnen bringt. Gelegentlich kann es etwas dauern, bis der allererste Scan online sichtbar wird.',
      dpd_note: 'Bitte beachten Sie: Bei DPD-Sendungen müssen Sie die Sendungsnummer möglicherweise kopieren und auf der DPD-Tracking-Seite erneut eingeben, um die neuesten Updates zu sehen.',
      tracking_label: 'Sendungsnummer',
      follow_label: 'Verfolgen Sie Ihre Sendung:',
      tracking_suffix: 'Sendungsverfolgung',
      delay_1: 'Bitte beachten Sie, dass internationale Tracking-Updates nicht immer in Echtzeit erfolgen. Es kann manchmal etwas dauern, bis die ersten physischen Scans und Transitereignisse online sichtbar werden &ndash; insbesondere während das Paket Ländergrenzen passiert.',
      delay_2: 'Sobald Ihre Sendung in Ihrem Zielland eintrifft und in das lokale Postnetzwerk aufgenommen wird, aktualisieren sich die Tracking-Informationen in der Regel deutlich häufiger.',
      closing_thanks: 'Wir schätzen Ihr Vertrauen sowie Ihre Geduld sehr und hoffen auf eine reibungslose und schnelle Zustellung.',
      closing_help: 'Sollten Sie Unterstützung benötigen, sind wir jederzeit gerne für Sie da. Antworten Sie dazu einfach auf diese E-Mail.',
      sign_off: 'Herzliche Grüße,',
      team: 'Ihr Kundenservice-Team',
      tel_label: 'Tel.:',
      rtl: false
    },
  'fr': {
      name_native: 'Français',
      subject: 'Votre commande Nutriop #{order} a été expédiée',
      badge: 'Commande expédiée',
      heading: 'La commande #{order} a été expédiée',
      greeting: 'Bonjour {firstName},',
      thanks: 'Merci pour votre commande chez Nutriop Longevity.',
      shipped_intro: 'Nous avons le plaisir de vous informer que votre commande <strong>#{order}</strong> a été expédiée et qu\'elle est actuellement en route vers vous.',
      routing: 'Votre colis a été expédié via notre service international suivi par <strong>{carrier}</strong> et sera confié à votre service postal local en <strong>{country}</strong> pour la livraison finale.',
      routing_courier: 'Votre commande est livrée directement à votre adresse en <strong>{country}</strong> par <strong>{carrier}</strong>. Vous pouvez suivre son acheminement à tout moment grâce au lien de suivi ci-dessous.',
      tracking_note_courier: 'Les informations de suivi apparaissent généralement peu après l\'expédition et se mettent à jour à chaque étape, à mesure que {carrier} achemine votre colis jusqu\'à vous. Il arrive parfois que le tout premier scan mette un peu de temps à s\'afficher en ligne.',
      dpd_note: 'À noter : pour les envois DPD, il se peut que vous deviez copier et saisir à nouveau le numéro de suivi sur la page de suivi DPD pour afficher les dernières informations.',
      tracking_label: 'Numéro de suivi',
      follow_label: 'Suivez votre expédition :',
      tracking_suffix: 'suivi',
      delay_1: 'Veuillez garder à l\'esprit que les mises à jour du suivi international ne sont pas toujours immédiates. Il peut parfois s\'écouler un court délai avant que les premiers scans physiques et les étapes de transit n\'apparaissent en ligne, en particulier lorsque le colis voyage d\'un pays à l\'autre.',
      delay_2: 'Une fois que votre colis sera arrivé dans votre pays et qu\'il aura intégré le réseau postal local, les informations de suivi s\'actualiseront normalement avec plus de régularité.',
      closing_thanks: 'Nous apprécions sincèrement votre patience et votre confiance, et nous espérons de tout cœur que la livraison sera rapide et sans encombre.',
      closing_help: 'Si vous avez besoin d\'aide, nous sommes toujours à votre disposition ; il vous suffit de répondre à cet e-mail.',
      sign_off: 'Bien à vous,',
      team: 'L\'équipe du Service Client',
      tel_label: 'Tél :',
      rtl: false
    },
  'it': {
      name_native: 'Italiano',
      subject: 'Il tuo ordine Nutriop #{order} è stato spedito',
      badge: 'Ordine Spedito',
      heading: 'L\'ordine #{order} è stato spedito',
      greeting: 'Gentile {firstName},',
      thanks: 'Grazie per il tuo ordine con Nutriop Longevity.',
      shipped_intro: 'Siamo lieti di informarti che il tuo ordine <strong>#{order}</strong> è stato spedito ed è in viaggio verso di te.',
      routing: 'Il tuo pacco è stato inviato tramite il nostro servizio di spedizione internazionale tracciabile con <strong>{carrier}</strong> e sarà affidato al servizio postale locale in <strong>{country}</strong> per la consegna finale.',
      routing_courier: 'Il tuo ordine viene consegnato direttamente al tuo indirizzo in <strong>{country}</strong> tramite <strong>{carrier}</strong>. Puoi seguire la spedizione in qualsiasi momento tramite il link di tracciamento qui sotto.',
      tracking_note_courier: 'Le informazioni di tracciamento compaiono solitamente poco dopo la spedizione e si aggiornano a ogni fase, mentre {carrier} porta il tuo pacco fino a te. A volte la primissima scansione può richiedere un po\' di tempo per apparire online.',
      dpd_note: 'Nota: per le spedizioni DPD, potrebbe essere necessario copiare e inserire nuovamente il numero di tracciamento nella pagina di tracciamento DPD per visualizzare gli ultimi aggiornamenti.',
      tracking_label: 'Numero di Tracciamento',
      follow_label: 'Segui la tua spedizione:',
      tracking_suffix: 'tracciamento',
      delay_1: 'Ti ricordiamo che gli aggiornamenti del tracciamento internazionale non sono sempre immediati. A volte può trascorrere un breve periodo prima che le prime scansioni fisiche e gli aggiornamenti di transito appaiano online, in particolare mentre il pacco è in viaggio da un Paese all\'altro.',
      delay_2: 'Una volta che la tua spedizione sarà arrivata nel tuo Paese e presa in carico dalla rete postale locale, le informazioni di tracciamento si aggiorneranno con maggiore regolarità.',
      closing_thanks: 'Apprezziamo sinceramente la tua pazienza e la tua fiducia, e ci auguriamo che la consegna proceda in modo rapido e senza intoppi.',
      closing_help: 'Se hai bisogno di qualsiasi assistenza, siamo sempre a tua disposizione: ti basterà rispondere a questa email.',
      sign_off: 'Cordiali saluti,',
      team: 'Il Team di Assistenza Clienti',
      tel_label: 'Tel:',
      rtl: false
    },
  'es': {
      name_native: 'Español',
      subject: 'Tu pedido de Nutriop #{order} ha sido enviado',
      badge: 'Pedido Enviado',
      heading: 'El pedido #{order} ha sido enviado',
      greeting: 'Estimado/a {firstName},',
      thanks: 'Gracias por tu pedido en Nutriop Longevity.',
      shipped_intro: 'Nos complace informarte que tu pedido <strong>#{order}</strong> ya ha sido enviado y está de camino.',
      routing: 'Tu paquete ha sido enviado a través de nuestro servicio internacional con seguimiento mediante <strong>{carrier}</strong> y será transferido a tu servicio postal local en <strong>{country}</strong> para la entrega final.',
      routing_courier: 'Tu pedido se entrega directamente en tu dirección en <strong>{country}</strong> a través de <strong>{carrier}</strong>. Puedes seguir su recorrido en cualquier momento mediante el enlace de seguimiento que aparece a continuación.',
      tracking_note_courier: 'La información de seguimiento suele aparecer poco después del envío y se actualiza en cada etapa, a medida que {carrier} lleva tu paquete hasta ti. En ocasiones, el primer escaneo puede tardar un poco en mostrarse en línea.',
      dpd_note: 'Ten en cuenta: para los envíos DPD, es posible que debas copiar y volver a introducir el número de seguimiento en la página de seguimiento de DPD para ver las últimas actualizaciones.',
      tracking_label: 'Número de seguimiento',
      follow_label: 'Sigue tu envío:',
      tracking_suffix: 'seguimiento',
      delay_1: 'Ten en cuenta que las actualizaciones del seguimiento internacional no siempre son inmediatas. En ocasiones, puede pasar un breve período de tiempo antes de que los primeros escaneos físicos y eventos de tránsito aparezcan en línea, especialmente mientras el paquete se traslada de un país a otro.',
      delay_2: 'Una vez que tu envío llegue a tu país y entre en la red postal local, la información de seguimiento normalmente se actualizará con mayor regularidad.',
      closing_thanks: 'Apreciamos sinceramente tu paciencia y confianza, y confiamos en que la entrega se realice de manera rápida y sin contratiempos.',
      closing_help: 'Si necesitas asistencia, siempre estamos a tu disposición; simplemente responde a este correo electrónico.',
      sign_off: 'Saludos cordiales,',
      team: 'El equipo de atención al cliente',
      tel_label: 'Tel.:',
      rtl: false
    },
    'nl': {
      name_native: 'Nederlands',
      subject: 'Uw Nutriop bestelling #{order} is verzonden',
      badge: 'Bestelling verzonden',
      heading: 'Bestelling #{order} is verzonden',
      greeting: 'Beste {firstName},',
      thanks: 'Hartelijk dank voor uw bestelling bij Nutriop Longevity.',
      shipped_intro: 'We laten u graag weten dat uw bestelling <strong>#{order}</strong> is verzonden en naar u onderweg is.',
      routing: 'Uw pakket is verzonden via onze internationale traceerbare bezorgdienst via <strong>{carrier}</strong> en zal voor de uiteindelijke bezorging worden overgedragen aan uw lokale postbezorger in <strong>{country}</strong>.',
      routing_courier: 'Uw bestelling wordt rechtstreeks op uw adres in <strong>{country}</strong> bezorgd door <strong>{carrier}</strong>. U kunt de zending op elk moment volgen via de onderstaande trackinglink.',
      tracking_note_courier: 'De trackinggegevens verschijnen doorgaans kort na verzending en worden bij elke stap bijgewerkt terwijl {carrier} uw pakket naar u onderweg brengt. Soms kan het even duren voordat de allereerste scan online zichtbaar is.',
      dpd_note: 'Let op: voor DPD-zendingen moet u het trackingnummer mogelijk kopiëren en opnieuw invoeren op de DPD-trackingpagina om de meest recente updates te zien.',
      tracking_label: 'Trackingnummer',
      follow_label: 'Volg uw zending:',
      tracking_suffix: 'tracking',
      delay_1: 'Houd er rekening mee dat internationale tracking-updates niet altijd onmiddellijk zichtbaar zijn. Het kan soms even duren voordat de eerste fysieke scans en transitgebeurtenissen online verschijnen, vooral wanneer het pakket zich tussen verschillende landen verplaatst.',
      delay_2: 'Zodra uw zending in uw land aankomt en in het lokale postnetwerk wordt opgenomen, zal de trackinginformatie normaal gesproken regelmatiger worden bijgewerkt.',
      closing_thanks: 'We waarderen uw geduld en vertrouwen enorm, en we hopen op een vlotte en snelle bezorging.',
      closing_help: 'Mocht u hulp nodig hebben, dan staan we altijd voor u klaar. U kunt hiervoor simpelweg deze e-mail beantwoorden.',
      sign_off: 'Met vriendelijke groet,',
      team: 'Het Klantenservice Team',
      tel_label: 'Tel:',
      rtl: false
    },
 'pt': {
      name_native: 'Português',
      subject: 'A sua encomenda Nutriop #{order} foi expedida',
      badge: 'Encomenda Expedida',
      heading: 'A encomenda #{order} foi expedida',
      greeting: 'Caro/a {firstName},',
      thanks: 'Obrigado pela sua encomenda na Nutriop Longevity.',
      shipped_intro: 'Temos o prazer de informar que a sua encomenda <strong>#{order}</strong> já foi expedida e está a caminho.',
      routing: 'O seu pacote foi enviado através do nosso serviço de entrega internacional com rastreio via <strong>{carrier}</strong> e será transferido para a transportadora postal local em <strong>{country}</strong> para a entrega final.',
      routing_courier: 'A sua encomenda é entregue diretamente na sua morada em <strong>{country}</strong> pela <strong>{carrier}</strong>. Pode acompanhar o seu percurso a qualquer momento através do link de rastreio abaixo.',
      tracking_note_courier: 'As informações de rastreio costumam aparecer pouco depois da expedição e são atualizadas em cada etapa, à medida que a {carrier} leva a sua encomenda até si. Por vezes, a primeira leitura pode demorar um pouco a ficar visível online.',
      dpd_note: 'Atenção: para envios DPD, poderá ter de copiar e voltar a introduzir o número de rastreio na página de rastreio da DPD para ver as atualizações mais recentes.',
      tracking_label: 'Número de Rastreio',
      follow_label: 'Acompanhe o seu envio:',
      tracking_suffix: 'rastreio',
      delay_1: 'Por favor, tenha em atenção que as atualizações de rastreio internacional nem sempre são imediatas. Por vezes, pode demorar um curto período até que as primeiras leituras físicas e os eventos de trânsito fiquem visíveis online, especialmente enquanto a encomenda viaja entre países.',
      delay_2: 'Assim que a sua encomenda chegar ao seu país e entrar na rede postal local, as informações de rastreio serão normalmente atualizadas com maior regularidade.',
      closing_thanks: 'Agradecemos sinceramente a sua paciência e confiança, e esperamos que a sua entrega seja rápida e sem contratempos.',
      closing_help: 'Se precisar de alguma assistência, estamos sempre à sua disposição. Basta responder a este e-mail.',
      sign_off: 'Com os melhores cumprimentos,',
      team: 'Equipa de Apoio ao Cliente',
      tel_label: 'Tel:',
      rtl: false
    },
 'bg': {
      name_native: 'Български',
      subject: 'Вашата Nutriop поръчка #{order} е изпратена',
      badge: 'Изпратена поръчка',
      heading: 'Поръчка #{order} е изпратена',
      greeting: 'Уважаеми/а {firstName},',
      thanks: 'Благодарим Ви за Вашата поръчка от Nutriop Longevity.',
      shipped_intro: 'Имаме удоволствието да Ви информираме, че Вашата поръчка <strong>#{order}</strong> вече е изпратена и пътува към Вас.',
      routing: 'Вашата пратка е изпратена чрез нашата международна услуга с проследяване чрез <strong>{carrier}</strong> и ще бъде предадена на местния пощенски оператор в <strong>{country}</strong> за крайна доставка.',
      routing_courier: 'Вашата поръчка се доставя директно до Вашия адрес в <strong>{country}</strong> от <strong>{carrier}</strong>. Можете да проследявате пратката по всяко време чрез връзката за проследяване по-долу.',
      tracking_note_courier: 'Информацията за проследяване обикновено се появява скоро след изпращането и се актуализира на всеки етап, докато {carrier} доставя Вашата пратка до Вас. Понякога може да отнеме малко време, преди първото сканиране да се покаже онлайн.',
      dpd_note: 'Моля, обърнете внимание: при пратки с DPD може да се наложи да копирате и въведете отново номера за проследяване на страницата за проследяване на DPD, за да видите най-новите актуализации.',
      tracking_label: 'Номер за проследяване',
      follow_label: 'Проследете Вашата пратка:',
      tracking_suffix: 'проследяване',
      delay_1: 'Моля, имайте предвид, че международните актуализации при проследяване не винаги са незабавни. Понякога може да отнеме кратък период от време, преди първите физически сканирания и транзитни събития да се появят онлайн, особено докато пратката се движи между държавите.',
      delay_2: 'След като Вашата пратка пристигне във Вашата държава и влезе в местната пощенска мрежа, информацията за проследяване обикновено ще се актуализира по-редовно.',
      closing_thanks: 'Искрено оценяваме Вашето търпение и доверие и се надяваме на безпроблемна и бърза доставка.',
      closing_help: 'Ако имате нужда от съдействие, ние сме винаги на Ваше разположение – просто отговорете на този имейл.',
      sign_off: 'С уважение,',
      team: 'Екипът за обслужване на клиенти',
      tel_label: 'Тел:',
      rtl: false
    },
 'hr': {
      name_native: 'Hrvatski',
      subject: 'Vaša Nutriop narudžba #{order} je poslana',
      badge: 'Narudžba poslana',
      heading: 'Narudžba #{order} je poslana',
      greeting: 'Poštovani/a {firstName},',
      thanks: 'Hvala Vam na Vašoj narudžbi kod Nutriop Longevity.',
      shipped_intro: 'Zadovoljstvo nam je obavijestiti Vas da je Vaša narudžba <strong>#{order}</strong> upravo poslana i na putu je prema Vama.',
      routing: 'Vaš paket je poslan putem naše međunarodne usluge praćene dostave preko <strong>{carrier}</strong> te će biti predan Vašoj lokalnoj poštanskoj službi u <strong>{country}</strong> za konačnu dostavu.',
      routing_courier: 'Vaša narudžba dostavlja se izravno na Vašu adresu u <strong>{country}</strong> putem <strong>{carrier}</strong>. Pošiljku možete pratiti u svakom trenutku putem poveznice za praćenje u nastavku.',
      tracking_note_courier: 'Podaci o praćenju obično se pojavljuju ubrzo nakon slanja i ažuriraju se u svakoj fazi dok {carrier} dostavlja Vaš paket do Vas. Ponekad može proći malo vremena dok se prvo skeniranje ne prikaže online.',
      dpd_note: 'Napomena: za pošiljke DPD-om možda ćete morati kopirati i ponovno unijeti broj za praćenje na stranici za praćenje DPD-a kako biste vidjeli najnovije podatke.',
      tracking_label: 'Broj za praćenje',
      follow_label: 'Pratite svoju pošiljku:',
      tracking_suffix: 'praćenje',
      delay_1: 'Molimo imajte na umu da ažuriranja međunarodnog praćenja nisu uvijek trenutna. Ponekad je potrebno kraće vrijeme da se prva fizička skeniranja i podaci o tranzitu pojave online, osobito dok paket putuje između država.',
      delay_2: 'Nakon što Vaša pošiljka stigne u Vašu zemlju i uđe u lokalnu poštansku mrežu, informacije o praćenju obično će se redovitije ažurirati.',
      closing_thanks: 'Iskreno cijenimo Vaše strpljenje i povjerenje te se nadamo brzoj dostavi bez poteškoća.',
      closing_help: 'Ako trebate bilo kakvu pomoć, uvijek smo tu za Vas. Jednostavno odgovorite na ovaj e-mail.',
      sign_off: 'Srdačan pozdrav,',
      team: 'Tim za korisničku podršku',
      tel_label: 'Tel:',
      rtl: false
    },
'cs': {
      name_native: 'Čeština',
      subject: 'Vaše objednávka Nutriop #{order} byla odeslána',
      badge: 'Objednávka odeslána',
      heading: 'Objednávka #{order} byla odeslána',
      greeting: 'Vážený/á {firstName},',
      thanks: 'Děkujeme Vám za Vaši objednávku u Nutriop Longevity.',
      shipped_intro: 'S potěšením Vám oznamujeme, že Vaše objednávka <strong>#{order}</strong> byla právě odeslána a je na cestě k Vám.',
      routing: 'Váš balíček byl odeslán prostřednictvím naší mezinárodní sledované doručovací služby přes <strong>{carrier}</strong> a bude předán Vašemu místnímu dopravci v zemi <strong>{country}</strong> pro konečné doručení.',
      routing_courier: 'Vaše objednávka je doručována přímo na Vaši adresu v zemi <strong>{country}</strong> prostřednictvím <strong>{carrier}</strong>. Zásilku můžete kdykoli sledovat pomocí odkazu pro sledování níže.',
      tracking_note_courier: 'Informace o sledování se obvykle objeví krátce po odeslání a aktualizují se v každé fázi, jak {carrier} doručuje Váš balík k Vám. Občas může chvíli trvat, než se úplně první sken zobrazí online.',
      dpd_note: 'Upozornění: u zásilek DPD může být nutné zkopírovat a znovu zadat sledovací číslo na stránce sledování DPD, abyste viděli nejnovější informace.',
      tracking_label: 'Sledovací číslo',
      follow_label: 'Sledujte svou zásilku:',
      tracking_suffix: 'sledování',
      delay_1: 'Vezměte prosím na vědomí, že mezinárodní aktualizace sledování nejsou vždy okamžité. Někdy může chvíli trvat, než se první fyzická skenování a informace o přepravě objeví online, zejména když se balíček přesouvá mezi zeměmi.',
      delay_2: 'Jakmile Vaše zásilka dorazí do Vaší země a vstoupí do místní poštovní sítě, informace o sledování se obvykle začnou aktualizovat častěji.',
      closing_thanks: 'Velmi si vážíme Vaší trpělivosti a důvěry a pevně věříme v bezproblémové a rychlé doručení.',
      closing_help: 'Pokud potřebujete s čímkoli pomoci, jsme Vám vždy k dispozici. Stačí jednoduše odpovědět na tento e-mail.',
      sign_off: 'S pozdravem,',
      team: 'Tým zákaznické podpory',
      tel_label: 'Tel.:',
      rtl: false
    },
'da': {
      name_native: 'Dansk',
      subject: 'Din Nutriop-ordre #{order} er blevet afsendt',
      badge: 'Ordre afsendt',
      heading: 'Ordre #{order} er afsendt',
      greeting: 'Kære {firstName},',
      thanks: 'Tak for din ordre hos Nutriop Longevity.',
      shipped_intro: 'Det glæder os at kunne fortælle, at din ordre <strong>#{order}</strong> nu er afsendt og er på vej til dig.',
      routing: 'Din pakke er sendt via vores internationale sporbare leveringsservice gennem <strong>{carrier}</strong> og vil blive overdraget til dit lokale postvæsen i <strong>{country}</strong> til den endelige levering.',
      routing_courier: 'Din ordre leveres direkte til din adresse i <strong>{country}</strong> af <strong>{carrier}</strong>. Du kan følge forsendelsen når som helst via sporingslinket nedenfor.',
      tracking_note_courier: 'Sporingsoplysningerne vises som regel kort efter afsendelsen og opdateres ved hvert trin, mens {carrier} bringer din pakke frem til dig. Nogle gange kan det tage lidt tid, før den allerførste scanning vises online.',
      dpd_note: 'Bemærk: for DPD-forsendelser skal du muligvis kopiere og indtaste sporingsnummeret igen på DPD\'s sporingsside for at se de seneste opdateringer.',
      tracking_label: 'Sporingsnummer',
      follow_label: 'Følg din forsendelse:',
      tracking_suffix: 'sporing',
      delay_1: 'Husk venligst, at internationale sporingsopdateringer ikke altid sker øjeblikkeligt. Det kan nogle gange tage lidt tid, før de første fysiske scanninger og transithændelser vises online, især mens pakken bevæger sig mellem lande.',
      delay_2: 'Når din forsendelse ankommer til dit land og overgår til det lokale postnetværk, vil sporingsoplysningerne normalt blive opdateret mere regelmæssigt.',
      closing_thanks: 'Vi sætter stor pris på din tålmodighed og tillid, og vi håber på en problemfri og hurtig levering.',
      closing_help: 'Hvis du har brug for hjælp, er vi altid klar til at assistere dig – du skal blot besvare denne e-mail.',
      sign_off: 'Med venlig hilsen,',
      team: 'Kundeserviceteamet',
      tel_label: 'Tlf.:',
      rtl: false
    },
    'et': {
      name_native: 'Eesti',
      subject: 'Teie Nutriop tellimus #{order} on teele pandud',
      badge: 'Tellimus teele pandud',
      heading: 'Tellimus #{order} on teele pandud',
      greeting: 'Hea {firstName},',
      thanks: 'Täname Teid Nutriop Longevity tellimuse eest.',
      shipped_intro: 'Meil on hea meel teatada, et Teie tellimus <strong>#{order}</strong> on nüüd teele pandud ja liigub Teie poole.',
      routing: 'Teie pakk saadeti meie rahvusvahelise jälgitava tarneteenusega <strong>{carrier}</strong> kaudu ning see antakse lõplikuks kohaletoimetamiseks üle Teie kohalikule postiteenistusele riigis <strong>{country}</strong>.',
      routing_courier: 'Teie tellimus toimetatakse otse Teie aadressile riigis <strong>{country}</strong> teenusepakkuja <strong>{carrier}</strong> kaudu. Saadetist saate igal ajal jälgida alloleva jälgimislingi abil.',
      tracking_note_courier: 'Jälgimisteave ilmub tavaliselt veidi pärast saatmist ja seda uuendatakse igas etapis, kui {carrier} toimetab Teie paki kohale. Mõnikord võib esimese skaneeringu ilmumine veebi võtta veidi aega.',
      dpd_note: 'Pange tähele: DPD saadetiste puhul peate võib-olla jälgimisnumbri kopeerima ja DPD jälgimislehel uuesti sisestama, et näha viimaseid uuendusi.',
      tracking_label: 'Jälgimisnumber',
      follow_label: 'Jälgige oma saadetist:',
      tracking_suffix: 'jälgimine',
      delay_1: 'Palun arvestage, et rahvusvahelise jälgimise uuendused ei pruugi alati toimuda koheselt. Mõnikord võib minna veidi aega, enne kui esimesed füüsilised skaneerimised ja transpordisündmused veebis ilmuvad, eriti ajal, mil pakk liigub riikide vahel.',
      delay_2: 'Kui Teie saadetis jõuab sihtriiki ja siseneb kohalikku postivõrku, hakatakse jälgimisteavet tavaliselt tihemini uuendama.',
      closing_thanks: 'Hindame siiralt Teie kannatlikkust ja usaldust ning loodame, et kohaletoimetamine kulgeb sujuvalt ja kiiresti.',
      closing_help: 'Kui vajate abi, oleme alati Teie jaoks olemas – lihtsalt vastake sellele e-kirjale.',
      sign_off: 'Parimate soovidega,',
      team: 'Klienditoe meeskond',
      tel_label: 'Tel:',
      rtl: false
    },
'fi': {
      name_native: 'Suomi',
      subject: 'Nutriop-tilauksesi #{order} on lähetetty',
      badge: 'Tilaus lähetetty',
      heading: 'Tilaus #{order} on lähetetty',
      greeting: 'Hyvä {firstName},',
      thanks: 'Kiitos tilauksestasi Nutriop Longevitylta.',
      shipped_intro: 'Meillä on ilo ilmoittaa, että tilauksesi <strong>#{order}</strong> on nyt lähetetty ja se on matkalla luoksesi.',
      routing: 'Pakettisi on lähetetty kansainvälisellä seurantapalvelullamme <strong>{carrier}</strong>-palvelun kautta, ja se siirretään paikalliselle postinjakelijallesi maassa <strong>{country}</strong> lopullista toimitusta varten.',
      routing_courier: 'Tilauksesi toimitetaan suoraan osoitteeseesi maassa <strong>{country}</strong> palveluntarjoajan <strong>{carrier}</strong> kautta. Voit seurata lähetystä milloin tahansa alla olevasta seurantalinkistä.',
      tracking_note_courier: 'Seurantatiedot tulevat yleensä näkyviin pian lähetyksen jälkeen ja päivittyvät jokaisessa vaiheessa, kun {carrier} tuo pakettiasi sinulle. Joskus ensimmäisen skannauksen ilmestyminen verkkoon voi kestää hetken.',
      dpd_note: 'Huomaa: DPD-lähetyksissä sinun on ehkä kopioitava ja syötettävä seurantanumero uudelleen DPD:n seurantasivulla nähdäksesi uusimmat päivitykset.',
      tracking_label: 'Seurantanumero',
      follow_label: 'Seuraa lähetystäsi:',
      tracking_suffix: 'seuranta',
      delay_1: 'Huomaathan, että kansainväliset seurantapäivitykset eivät aina näy välittömästi. Voi toisinaan kestää pienen hetken, ennen kuin ensimmäiset fyysiset skannaukset ja kuljetustapahtumat näkyvät verkossa, erityisesti silloin, kun paketti siirtyy maasta toiseen.',
      delay_2: 'Kun lähetyksesi saapuu kohdemaahan ja siirtyy paikalliseen postiverkostoon, seurantatiedot päivittyvät yleensä säännöllisemmin.',
      closing_thanks: 'Arvostamme suuresti kärsivällisyyttäsi ja luottamustasi, ja toivomme, että toimitus sujuu nopeasti ja vaivattomasti.',
      closing_help: 'Jos tarvitset apua, olemme aina täällä sinua varten – vastaa vain tähän sähköpostiin.',
      sign_off: 'Ystävällisin terveisin,',
      team: 'Asiakaspalvelutiimi',
      tel_label: 'Puh:',
      rtl: false
    },
'el': {
      name_native: 'Ελληνικά',
      subject: 'Η παραγγελία σας από τη Nutriop #{order} έχει αποσταλεί',
      badge: 'Η Παραγγελία Απεστάλη',
      heading: 'Η παραγγελία #{order} έχει αποσταλεί',
      greeting: 'Αγαπητέ/ή {firstName},',
      thanks: 'Σας ευχαριστούμε για την παραγγελία σας από τη Nutriop Longevity.',
      shipped_intro: 'Είμαστε στην ευχάριστη θέση να σας ενημερώσουμε ότι η παραγγελία σας <strong>#{order}</strong> έχει πλέον αποσταλεί και είναι καθ\' οδόν προς εσάς.',
      routing: 'Το δέμα σας έχει σταλεί μέσω της υπηρεσίας διεθνούς παρακολούθησης αποστολών με την <strong>{carrier}</strong> και θα μεταβιβαστεί στον τοπικό ταχυδρομικό φορέα σε <strong>{country}</strong> για την τελική παράδοση.',
      routing_courier: 'Η παραγγελία σας παραδίδεται απευθείας στη διεύθυνσή σας σε <strong>{country}</strong> μέσω της <strong>{carrier}</strong>. Μπορείτε να παρακολουθείτε την αποστολή ανά πάσα στιγμή μέσω του παρακάτω συνδέσμου παρακολούθησης.',
      tracking_note_courier: 'Οι πληροφορίες παρακολούθησης εμφανίζονται συνήθως λίγο μετά την αποστολή και ενημερώνονται σε κάθε στάδιο, καθώς η {carrier} φέρνει το δέμα σας σε εσάς. Ορισμένες φορές η πρώτη σάρωση μπορεί να χρειαστεί λίγο χρόνο για να εμφανιστεί στο διαδίκτυο.',
      dpd_note: 'Σημείωση: για τις αποστολές DPD, ενδέχεται να χρειαστεί να αντιγράψετε και να εισαγάγετε ξανά τον αριθμό παρακολούθησης στη σελίδα παρακολούθησης της DPD για να δείτε τις πιο πρόσφατες ενημερώσεις.',
      tracking_label: 'Αριθμός Παρακολούθησης',
      follow_label: 'Παρακολουθήστε την αποστολή σας:',
      tracking_suffix: 'παρακολούθηση',
      delay_1: 'Λάβετε υπόψη ότι οι ενημερώσεις της διεθνούς παρακολούθησης δεν είναι πάντα άμεσες. Ορισμένες φορές μπορεί να χρειαστεί ένα μικρό χρονικό διάστημα για να εμφανιστούν ηλεκτρονικά οι πρώτες φυσικές σαρώσεις και τα συμβάντα διαμετακόμισης, ιδιαίτερα καθώς το δέμα μετακινείται μεταξύ χωρών.',
      delay_2: 'Μόλις η αποστολή σας φτάσει στη χώρα σας και εισέλθει στο τοπικό ταχυδρομικό δίκτυο, οι πληροφορίες παρακολούθησης συνήθως θα ενημερώνονται πιο τακτικά.',
      closing_thanks: 'Εκτιμούμε ειλικρινά την υπομονή και την εμπιστοσύνη σας, και ευελπιστούμε για μια ομαλή και γρήγορη παράδοση.',
      closing_help: 'Εάν χρειάζεστε οποιαδήποτε βοήθεια, είμαστε πάντα στη διάθεσή σας, απλώς απαντήστε σε αυτό το email.',
      sign_off: 'Με εκτίμηση,',
      team: 'Ομάδα Εξυπηρέτησης Πελατών',
      tel_label: 'Τηλ:',
      rtl: false
    },
'hu': {
      name_native: 'Magyar',
      subject: 'A Nutriop rendelése #{order} feladásra került',
      badge: 'Rendelés feladva',
      heading: 'A(z) #{order} számú rendelés feladva',
      greeting: 'Kedves {firstName},',
      thanks: 'Köszönjük a Nutriop Longevity-nél leadott rendelését.',
      shipped_intro: 'Örömmel értesítjük, hogy a <strong>#{order}</strong> számú rendelését feladtuk, és már úton van Ön felé.',
      routing: 'Csomagja nemzetközi, nyomon követhető szállítási szolgáltatásunkkal indult el a(z) <strong>{carrier}</strong> hálózatán keresztül, majd a végső kézbesítéshez átadjuk a helyi postai szolgáltatónak (<strong>{country}</strong>).',
      routing_courier: 'Rendelését közvetlenül az Ön címére kézbesítjük itt: <strong>{country}</strong>, a(z) <strong>{carrier}</strong> futárszolgálattal. A küldeményt bármikor nyomon követheti az alábbi nyomonkövetési hivatkozással.',
      tracking_note_courier: 'A nyomon követési adatok általában röviddel a feladás után jelennek meg, és minden szakaszban frissülnek, ahogy a(z) {carrier} elhozza Önnek a csomagját. Időnként a legelső beolvasás megjelenése az interneten eltarthat egy kis ideig.',
      dpd_note: 'Felhívjuk figyelmét: DPD-küldemények esetén előfordulhat, hogy a nyomon követési számot ki kell másolnia és újra meg kell adnia a DPD nyomon követési oldalán a legfrissebb információk megtekintéséhez.',
      tracking_label: 'Nyomonkövetési szám',
      follow_label: 'Kövesse nyomon a küldeményét:',
      tracking_suffix: 'nyomon követés',
      delay_1: 'Kérjük, vegye figyelembe, hogy a nemzetközi nyomon követési adatok frissítése nem mindig azonnali. Esetenként rövid időbe telhet, amíg az első fizikai beolvasások és a szállítási események megjelennek a rendszerben, különösen akkor, amikor a csomag országok között halad.',
      delay_2: 'Amint a küldemény megérkezik az Ön országába, és bekerül a helyi postai hálózatba, a nyomon követési információk általában rendszeresebben frissülnek.',
      closing_thanks: 'Őszintén köszönjük a türelmét és a bizalmát, és bízunk a zökkenőmentes és gyors kézbesítésben.',
      closing_help: 'Ha bármilyen segítségre van szüksége, mindig készséggel állunk rendelkezésére – elegendő csupán válaszolnia erre az e-mailre.',
      sign_off: 'Üdvözlettel,',
      team: 'Ügyfélszolgálati csapat',
      tel_label: 'Tel.:',
      rtl: false
    },
'is': {
      name_native: 'Íslenska',
      subject: 'Nutriop pöntunin þín #{order} hefur verið send',
      badge: 'Pöntun send',
      heading: 'Pöntun #{order} hefur verið send',
      greeting: 'Kæri / Kæra {firstName},',
      thanks: 'Takk fyrir pöntunina þína hjá Nutriop Longevity.',
      shipped_intro: 'Það gleður okkur að láta þig vita að pöntunin þín <strong>#{order}</strong> hefur nú verið send og er á leiðinni til þín.',
      routing: 'Pakkinn þinn var sendur með alþjóðlegri rekjanlegri sendingarþjónustu okkar í gegnum <strong>{carrier}</strong> og verður afhentur staðbundinni póstþjónustu í <strong>{country}</strong> til endanlegrar afhendingar.',
      routing_courier: 'Pöntunin þín er afhent beint á heimilisfangið þitt í <strong>{country}</strong> með <strong>{carrier}</strong>. Þú getur fylgst með sendingunni hvenær sem er með rakningarhlekknum hér að neðan.',
      tracking_note_courier: 'Rakningarupplýsingar birtast yfirleitt skömmu eftir sendingu og uppfærast á hverju stigi á meðan {carrier} kemur pakkanum þínum til þín. Stundum getur tekið smá tíma fyrir allra fyrstu skönnunina að birtast á netinu.',
      dpd_note: 'Athugið: fyrir DPD-sendingar gætirðu þurft að afrita og slá rakningarnúmerið aftur inn á rakningarsíðu DPD til að sjá nýjustu upplýsingar.',
      tracking_label: 'Rakningarnúmer',
      follow_label: 'Fylgstu með sendingunni þinni:',
      tracking_suffix: 'rakning',
      delay_1: 'Vinsamlegast hafðu í huga að alþjóðlegar uppfærslur á rakningu eru ekki alltaf samstundis. Það getur stundum tekið stuttan tíma fyrir fyrstu skannanir og upplýsingar um flutning að birtast á netinu, sérstaklega á meðan pakkinn er á ferð milli landa.',
      delay_2: 'Þegar sendingin þín er komin til landsins og fer inn í staðbundið póstkerfi, munu rakningarupplýsingar venjulega uppfærast oftar.',
      closing_thanks: 'Við kunnum virkilega að meta þolinmæði þína og traust og vonum að afhendingin gangi hratt og snurðulaust fyrir sig.',
      closing_help: 'Ef þú þarft á aðstoð að halda erum við alltaf til taks; einfaldlega svaraðu þessum tölvupósti.',
      sign_off: 'Kær kveðja,',
      team: 'Þjónustuteymi viðskiptavina',
      tel_label: 'Sími:',
      rtl: false
    },
   'lv': {
      name_native: 'Latviešu',
      subject: 'Jūsu Nutriop pasūtījums #{order} ir nosūtīts',
      badge: 'Pasūtījums nosūtīts',
      heading: 'Pasūtījums #{order} ir nosūtīts',
      greeting: 'Cien. {firstName},',
      thanks: 'Paldies par Jūsu Nutriop Longevity pasūtījumu.',
      shipped_intro: 'Ar prieku paziņojam, ka Jūsu pasūtījums <strong>#{order}</strong> ir nosūtīts un atrodas ceļā pie Jums.',
      routing: 'Jūsu sūtījums tika nosūtīts, izmantojot mūsu starptautisko izsekojamo piegādes pakalpojumu (<strong>{carrier}</strong>), un tas tiks nodots vietējam pasta pakalpojumu sniedzējam (<strong>{country}</strong>) gala piegādei.',
      routing_courier: 'Jūsu pasūtījums tiek piegādāts tieši uz Jūsu adresi valstī <strong>{country}</strong>, izmantojot <strong>{carrier}</strong>. Sūtījumu jebkurā laikā varat izsekot, izmantojot zemāk esošo izsekošanas saiti.',
      tracking_note_courier: 'Izsekošanas informācija parasti parādās neilgi pēc nosūtīšanas un tiek atjaunināta katrā posmā, kamēr {carrier} piegādā Jūsu sūtījumu. Dažkārt pirmajam skenējumam var būt nepieciešams nedaudz laika, lai tas parādītos tiešsaistē.',
      dpd_note: 'Lūdzu, ņemiet vērā: DPD sūtījumiem, iespējams, izsekošanas numurs būs jākopē un atkārtoti jāievada DPD izsekošanas lapā, lai redzētu jaunāko informāciju.',
      tracking_label: 'Izsekošanas numurs',
      follow_label: 'Sekojiet līdzi savam sūtījumam:',
      tracking_suffix: 'izsekošana',
      delay_1: 'Lūdzu, ņemiet vērā, ka starptautiskās izsekošanas informācija ne vienmēr atjauninās uzreiz. Dažkārt var paiet neilgs laiks, līdz tiešsaistē parādās pirmie fiziskie skenējumi un tranzīta notikumi, jo īpaši, kamēr sūtījums pārvietojas starp valstīm.',
      delay_2: 'Tiklīdz Jūsu sūtījums ieradīsies Jūsu valstī un nonāks vietējā pasta tīklā, izsekošanas informācija parasti tiks atjaunināta biežāk.',
      closing_thanks: 'Mēs patiesi novērtējam Jūsu pacietību un uzticību, un ceram uz raitu un ātru piegādi.',
      closing_help: 'Ja Jums nepieciešama palīdzība, mēs vienmēr esam gatavi palīdzēt – vienkārši atbildiet uz šo e-pastu.',
      sign_off: 'Ar cieņu,',
      team: 'Klientu apkalpošanas komanda',
      tel_label: 'Tālr.:',
      rtl: false
    },
'lt': {
      name_native: 'Lietuvių',
      subject: 'Jūsų Nutriop užsakymas #{order} išsiųstas',
      badge: 'Užsakymas išsiųstas',
      heading: 'Užsakymas #{order} išsiųstas',
      greeting: 'Gerb. {firstName},',
      thanks: 'Dėkojame už Jūsų „Nutriop Longevity“ užsakymą.',
      shipped_intro: 'Džiaugiamės galėdami pranešti, kad Jūsų užsakymas <strong>#{order}</strong> jau išsiųstas ir keliauja pas Jus.',
      routing: 'Jūsų siunta išsiųsta pasinaudojant mūsų tarptautine sekamo pristatymo paslauga per <strong>{carrier}</strong> ir bus perduota vietiniam pašto paslaugų teikėjui šalyje <strong>{country}</strong> galutiniam pristatymui.',
      routing_courier: 'Jūsų užsakymas pristatomas tiesiai Jūsų adresu šalyje <strong>{country}</strong> per <strong>{carrier}</strong>. Siuntą bet kuriuo metu galite sekti naudodamiesi toliau pateikta sekimo nuoroda.',
      tracking_note_courier: 'Sekimo informacija paprastai pasirodo netrukus po išsiuntimo ir atnaujinama kiekviename etape, kol {carrier} pristato Jūsų siuntą. Kartais pirmasis nuskaitymas internete gali pasirodyti ne iš karto.',
      dpd_note: 'Atkreipkite dėmesį: DPD siuntų atveju gali tekti nukopijuoti ir iš naujo įvesti sekimo numerį DPD sekimo puslapyje, kad pamatytumėte naujausią informaciją.',
      tracking_label: 'Sekimo numeris',
      follow_label: 'Sekite savo siuntą:',
      tracking_suffix: 'sekimas',
      delay_1: 'Prašome atkreipti dėmesį, kad tarptautinio sekimo informacija ne visada atnaujinama akimirksniu. Gali prireikti šiek tiek laiko, kol sistemoje pasirodys pirmieji fiziniai nuskaitymai ir tranzito įvykiai, ypač kol siunta keliauja tarp valstybių.',
      delay_2: 'Kai Jūsų siunta pasieks Jūsų šalį ir bus perduota vietiniam pašto tinklui, sekimo informacija paprastai bus atnaujinama dažniau.',
      closing_thanks: 'Nuoširdžiai vertiname Jūsų kantrybę ir pasitikėjimą bei tikimės, kad siunta Jus pasieks sklandžiai ir greitai.',
      closing_help: 'Jei Jums prireiktų pagalbos, mes visada pasiruošę padėti – tiesiog atsakykite į šį el. laišką.',
      sign_off: 'Pagarbiai,',
      team: 'Klientų aptarnavimo komanda',
      tel_label: 'Tel.:',
      rtl: false
    },
'no': {
      name_native: 'Norsk',
      subject: 'Din Nutriop-bestilling #{order} er sendt',
      badge: 'Bestilling sendt',
      heading: 'Bestilling #{order} er sendt',
      greeting: 'Kjære {firstName},',
      thanks: 'Takk for din bestilling hos Nutriop Longevity.',
      shipped_intro: 'Det gleder oss å fortelle at bestillingen din <strong>#{order}</strong> nå er sendt og er på vei til deg.',
      routing: 'Pakken din har blitt sendt via vår internasjonale sporbare leveringstjeneste med <strong>{carrier}</strong>, og vil bli overlevert til din lokale posttjeneste i <strong>{country}</strong> for endelig levering.',
      routing_courier: 'Bestillingen din leveres direkte til adressen din i <strong>{country}</strong> av <strong>{carrier}</strong>. Du kan følge sendingen når som helst via sporingslenken nedenfor.',
      tracking_note_courier: 'Sporingsinformasjonen vises vanligvis kort tid etter sending og oppdateres ved hvert trinn mens {carrier} bringer pakken din frem til deg. Av og til kan det ta litt tid før den aller første skanningen vises på nettet.',
      dpd_note: 'Merk: for DPD-sendinger må du kanskje kopiere og skrive inn sporingsnummeret på nytt på DPDs sporingsside for å se de nyeste oppdateringene.',
      tracking_label: 'Sporingsnummer',
      follow_label: 'Følg sendingen din:',
      tracking_suffix: 'sporing',
      delay_1: 'Vennligst husk at internasjonale sporingsoppdateringer ikke alltid skjer umiddelbart. Det kan av og til ta litt tid før de første fysiske skanningene og hendelsene underveis vises på nettet, spesielt mens pakken forflytter seg mellom land.',
      delay_2: 'Når sendingen din ankommer landet ditt og overføres til det lokale postnettverket, vil sporingsinformasjonen normalt oppdateres oftere.',
      closing_thanks: 'Vi setter stor pris på din tålmodighet og tillit, og vi håper på en problemfri og rask levering.',
      closing_help: 'Hvis du trenger hjelp, er vi alltid her for deg. Du trenger bare å svare på denne e-posten.',
      sign_off: 'Med vennlig hilsen,',
      team: 'Kundeserviceteamet',
      tel_label: 'Tlf:',
      rtl: false
    },
    'pl': {
name_native: 'Polski',
subject: 'Twoje zamówienie Nutriop #{order} zostało wysłane',
badge: 'Zamówienie wysłane',
heading: 'Zamówienie #{order} jest już w drodze',
greeting: 'Dzień dobry, {firstName},',
thanks: 'Dziękujemy za złożenie zamówienia w Nutriop Longevity.',
shipped_intro: 'Z przyjemnością informujemy, że Twoje zamówienie <strong>#{order}</strong> zostało już wysłane i jest w drodze do Ciebie.',
routing: 'Twoja przesyłka została nadana za pośrednictwem naszej międzynarodowej usługi monitorowanej <strong>{carrier}</strong>. Po dotarciu do <strong>{country}</strong> zostanie przekazana lokalnemu operatorowi pocztowemu w celu finalizacji dostawy.',
routing_courier: 'Twoje zamówienie jest dostarczane bezpośrednio na Twój adres w <strong>{country}</strong> przez <strong>{carrier}</strong>. Przesyłkę możesz śledzić w dowolnym momencie, korzystając z poniższego linku do śledzenia.',
tracking_note_courier: 'Informacje o śledzeniu zwykle pojawiają się wkrótce po nadaniu i są aktualizowane na każdym etapie, gdy {carrier} dostarcza Twoją przesyłkę. Czasami pierwsze skanowanie może pojawić się w internecie z niewielkim opóźnieniem.',
dpd_note: 'Uwaga: w przypadku przesyłek DPD może być konieczne skopiowanie i ponowne wprowadzenie numeru śledzenia na stronie śledzenia DPD, aby zobaczyć najnowsze aktualizacje.',
tracking_label: 'Numer śledzenia',
follow_label: 'Śledź swoją przesyłkę:',
tracking_suffix: 'śledzenie',
delay_1: 'Prosimy pamiętać, że aktualizacje w systemach śledzenia przesyłek międzynarodowych nie zawsze pojawiają się natychmiastowo. Pierwsze fizyczne skanowanie paczki oraz informacje o statusie mogą pojawić się z pewnym opóźnieniem, szczególnie w czasie transportu między krajami.',
delay_2: 'Gdy przesyłka dotrze do Twojego kraju i zostanie zarejestrowana w lokalnej sieci pocztowej, informacje o śledzeniu będą aktualizowane regularnie.',
closing_thanks: 'Doceniamy Twoją cierpliwość i zaufanie. Mamy nadzieję, że przesyłka dotrze do Ciebie sprawnie i w jak najkrótszym czasie.',
closing_help: 'Jeśli potrzebujesz pomocy, jesteśmy do Twojej dyspozycji – po prostu odpowiedz na tę wiadomość.',
sign_off: 'Z poważaniem,',
team: 'Zespół Obsługi Klienta Nutriop',
tel_label: 'Tel:',
rtl: false
},
  'ro': {
      name_native: 'Română',
      subject: 'Comanda dvs. Nutriop #{order} a fost expediată',
      badge: 'Comandă expediată',
      heading: 'Comanda #{order} a fost expediată',
      greeting: 'Dragă {firstName},',
      thanks: 'Vă mulțumim pentru comanda plasată la Nutriop Longevity.',
      shipped_intro: 'Ne face plăcere să vă informăm că comanda dvs. <strong>#{order}</strong> a fost expediată și este în drum spre dvs.',
      routing: 'Coletul dvs. a fost trimis prin serviciul nostru internațional de livrare cu urmărire prin <strong>{carrier}</strong> și va fi predat serviciului poștal local din <strong>{country}</strong> pentru livrarea finală.',
      routing_courier: 'Comanda dvs. este livrată direct la adresa dvs. din <strong>{country}</strong> de către <strong>{carrier}</strong>. Puteți urmări expedierea în orice moment folosind linkul de urmărire de mai jos.',
      tracking_note_courier: 'Informațiile de urmărire apar de obicei la scurt timp după expediere și se actualizează la fiecare etapă, pe măsură ce {carrier} vă aduce coletul. Uneori, prima scanare poate dura puțin până să apară online.',
      dpd_note: 'Vă rugăm să rețineți: pentru expedierile DPD, este posibil să fie nevoie să copiați și să introduceți din nou numărul de urmărire pe pagina de urmărire DPD pentru a vedea cele mai recente actualizări.',
      tracking_label: 'Număr de urmărire',
      follow_label: 'Urmăriți expedierea:',
      tracking_suffix: 'urmărire',
      delay_1: 'Vă rugăm să aveți în vedere faptul că actualizările de urmărire internațională nu sunt întotdeauna imediate. Uneori poate dura o scurtă perioadă până când primele scanări fizice și evenimente de tranzit apar online, în special în timp ce coletul se deplasează între țări.',
      delay_2: 'Odată ce expedierea ajunge în țara dvs. și intră în rețeaua poștală locală, informațiile de urmărire se vor actualiza, în mod normal, mai regulat.',
      closing_thanks: 'Apreciem cu adevărat răbdarea și încrederea dvs. și sperăm la o livrare rapidă și fără probleme.',
      closing_help: 'Dacă aveți nevoie de asistență, suntem mereu aici pentru a vă ajuta – este suficient să răspundeți la acest e-mail.',
      sign_off: 'Cu deosebită considerație,',
      team: 'Echipa de Relații cu Clienții',
      tel_label: 'Tel:',
      rtl: false
    },
 'sk': {
      name_native: 'Slovenčina',
      subject: 'Vaša objednávka Nutriop #{order} bola odoslaná',
      badge: 'Objednávka odoslaná',
      heading: 'Objednávka #{order} bola odoslaná',
      greeting: 'Vážený/á {firstName},',
      thanks: 'Ďakujeme za Vašu objednávku u Nutriop Longevity.',
      shipped_intro: 'S radosťou Vám oznamujeme, že Vaša objednávka <strong>#{order}</strong> bola práve odoslaná a je na ceste k Vám.',
      routing: 'Váš balík bol odoslaný prostredníctvom našej medzinárodnej sledovanej doručovacej služby cez <strong>{carrier}</strong> a bude odovzdaný Vášmu miestnemu doručovateľovi v krajine <strong>{country}</strong> na konečné doručenie.',
      routing_courier: 'Vaša objednávka je doručovaná priamo na Vašu adresu v krajine <strong>{country}</strong> prostredníctvom <strong>{carrier}</strong>. Zásielku môžete kedykoľvek sledovať pomocou odkazu na sledovanie nižšie.',
      tracking_note_courier: 'Informácie o sledovaní sa zvyčajne zobrazia krátko po odoslaní a aktualizujú sa v každej fáze, kým {carrier} doručuje Vašu zásielku. Občas môže chvíľu trvať, kým sa úplne prvé naskenovanie zobrazí online.',
      dpd_note: 'Upozornenie: pri zásielkach DPD môže byť potrebné skopírovať a znova zadať sledovacie číslo na stránke sledovania DPD, aby ste videli najnovšie informácie.',
      tracking_label: 'Sledovacie číslo',
      follow_label: 'Sledujte svoju zásielku:',
      tracking_suffix: 'sledovanie',
      delay_1: 'Majte prosím na pamäti, že medzinárodné aktualizácie sledovania nie sú vždy okamžité. Niekedy môže chvíľu trvať, kým sa prvé fyzické skenovania a informácie o preprave objavia online, najmä keď sa balík presúva medzi krajinami.',
      delay_2: 'Akonáhle Vaša zásielka dorazí do Vašej krajiny a vstúpi do miestnej poštovej siete, informácie o sledovaní sa zvyčajne začnú aktualizovať častejšie.',
      closing_thanks: 'Veľmi si vážime Vašu trpezlivosť a dôveru a pevne veríme v bezproblémové a rýchle doručenie.',
      closing_help: 'Ak potrebujete s čímkoľvek pomôcť, sme Vám vždy k dispozícii – stačí jednoducho odpovedať na tento e-mail.',
      sign_off: 'S pozdravom,',
      team: 'Tím zákazníckej podpory',
      tel_label: 'Tel.:',
      rtl: false
    },
    'sl': {
      name_native: 'Slovenščina',
      subject: 'Vaše Nutriop naročilo #{order} je bilo odpremljeno',
      badge: 'Naročilo odpremljeno',
      heading: 'Naročilo #{order} je bilo odpremljeno',
      greeting: 'Spoštovani/a {firstName},',
      thanks: 'Zahvaljujemo se Vam za Vaše naročilo pri Nutriop Longevity.',
      shipped_intro: 'Z veseljem Vas obveščamo, da je bilo Vaše naročilo <strong>#{order}</strong> odpremljeno in je na poti k Vam.',
      routing: 'Vaš paket je bil poslan prek naše mednarodne sledljive dostavne službe (<strong>{carrier}</strong>) in bo predan Vaši lokalni poštni službi v državi <strong>{country}</strong> za končno dostavo.',
      routing_courier: 'Vaše naročilo je dostavljeno neposredno na Vaš naslov v državi <strong>{country}</strong> prek <strong>{carrier}</strong>. Pošiljko lahko kadar koli spremljate prek spodnje povezave za sledenje.',
      tracking_note_courier: 'Podatki o sledenju se običajno prikažejo kmalu po odpremi in se posodabljajo na vsaki stopnji, medtem ko {carrier} dostavlja Vašo pošiljko. Včasih lahko traja nekaj časa, da se prvo skeniranje prikaže na spletu.',
      dpd_note: 'Opomba: pri pošiljkah DPD boste morda morali kopirati in znova vnesti številko za sledenje na strani za sledenje DPD, da si ogledate najnovejše posodobitve.',
      tracking_label: 'Številka za sledenje',
      follow_label: 'Sledite svoji pošiljki:',
      tracking_suffix: 'sledenje',
      delay_1: 'Prosimo, upoštevajte, da posodobitve mednarodnega sledenja niso vedno takojšnje. Včasih lahko traja kratek čas, da se prva fizična skeniranja in tranzitni dogodki pojavijo na spletu, zlasti medtem ko paket potuje med državami.',
      delay_2: 'Ko Vaša pošiljka prispe v Vašo državo in vstopi v lokalno poštno omrežje, se bodo informacije o sledenju običajno posodabljale pogosteje.',
      closing_thanks: 'Iskreno cenimo Vašo potrpežljivost in zaupanje ter upamo na brezhibno in hitro dostavo.',
      closing_help: 'Če potrebujete kakršno koli pomoč, smo Vam vedno na voljo – preprosto odgovorite na to e-poštno sporočilo.',
      sign_off: 'Lep pozdrav,',
      team: 'Ekipa za podporo strankam',
      tel_label: 'Tel.:',
      rtl: false
    },
'sv': {
      name_native: 'Svenska',
      subject: 'Din Nutriop-beställning #{order} har skickats',
      badge: 'Beställning skickad',
      heading: 'Beställning #{order} har skickats',
      greeting: 'Hej {firstName},',
      thanks: 'Tack för din beställning hos Nutriop Longevity.',
      shipped_intro: 'Det gläder oss att meddela att din beställning <strong>#{order}</strong> nu har skickats och är på väg till dig.',
      routing: 'Ditt paket har skickats via vår internationella spårbara leveranstjänst med <strong>{carrier}</strong> och kommer att överlämnas till ditt lokala postombud i <strong>{country}</strong> för slutlig leverans.',
      routing_courier: 'Din beställning levereras direkt till din adress i <strong>{country}</strong> av <strong>{carrier}</strong>. Du kan följa försändelsen när som helst via spårningslänken nedan.',
      tracking_note_courier: 'Spårningsinformationen visas vanligtvis kort efter avsändning och uppdateras i varje steg medan {carrier} levererar ditt paket till dig. Ibland kan det ta en liten stund innan den allra första skanningen visas online.',
      dpd_note: 'Observera: för DPD-försändelser kan du behöva kopiera och ange spårningsnumret igen på DPD:s spårningssida för att se de senaste uppdateringarna.',
      tracking_label: 'Spårningsnummer',
      follow_label: 'Följ din försändelse:',
      tracking_suffix: 'spårning',
      delay_1: 'Vänligen tänk på att internationella spårningsuppdateringar inte alltid sker omedelbart. Det kan ibland ta en kort stund innan de första fysiska skanningarna och transithändelserna visas online, särskilt medan paketet förflyttas mellan länder.',
      delay_2: 'När din försändelse anländer till ditt land och övergår till det lokala postnätverket, uppdateras spårningsinformationen normalt sett mer regelbundet.',
      closing_thanks: 'Vi uppskattar verkligen ditt tålamod och förtroende, och vi hoppas på en smidig och snabb leverans.',
      closing_help: 'Om du behöver hjälp finns vi alltid här för dig – du behöver bara svara på det här e-postmeddelandet.',
      sign_off: 'Vänliga hälsningar,',
      team: 'Kundtjänstteamet',
      tel_label: 'Tel:',
      rtl: false
    },
  'he': {
name_native: 'עברית',
subject: 'הזמנת ה-Nutriop שלך מס\' #{order} יצאה לדרך',
badge: 'הזמנה נשלחה',
heading: 'הזמנה מס\' #{order} נשלחה',
greeting: 'שלום {firstName},',
thanks: 'תודה על הזמנתך מ-Nutriop Longevity.',
shipped_intro: 'אנו שמחים לעדכן אותך שהזמנתך <strong>#{order}</strong> נשלחה כעת והיא בדרכה אליך.',
routing: 'החבילה נשלחה באמצעות שירות המשלוחים הבינלאומי המנוטר שלנו דרך <strong>{carrier}</strong>, ותועבר לספק הדואר המקומי ב<strong>{country}</strong> לצורך המסירה הסופית.',
routing_courier: 'ההזמנה שלך נמסרת ישירות לכתובת שלך ב<strong>{country}</strong> באמצעות <strong>{carrier}</strong>. ניתן לעקוב אחר המשלוח בכל עת באמצעות קישור המעקב שמופיע למטה.',
tracking_note_courier: 'פרטי המעקב מופיעים בדרך כלל זמן קצר לאחר המשלוח ומתעדכנים בכל שלב, ככל ש-{carrier} מביאה אליך את החבילה. לעיתים ייקח מעט זמן עד שהסריקה הראשונה תופיע באינטרנט.',
dpd_note: 'שימו לב: עבור משלוחי DPD, ייתכן שתצטרכו להעתיק ולהזין מחדש את מספר המעקב בדף המעקב של DPD כדי לראות את העדכונים האחרונים.',
tracking_label: 'מספר מעקב',
follow_label: 'למעקב אחר המשלוח:',
tracking_suffix: 'מעקב',
delay_1: 'חשוב לזכור שעדכוני מעקב בינלאומיים אינם תמיד מיידיים. לעיתים חולף זמן קצר עד שהסריקות הפיזיות הראשונות ושינויי הסטטוס מופיעים במערכת המקוונת, במיוחד בזמן שהחבילה עוברת בין מדינות.',
delay_2: 'ברגע שהמשלוח יגיע לארצך וייכנס לרשת הדואר המקומית, פרטי המעקב יתעדכנו בדרך כלל באופן שוטף ועקבי יותר.',
closing_thanks: 'אנו מעריכים מאוד את הסבלנות והאמון שלך, ומצפים למסירה חלקה ומהירה של ההזמנה.',
closing_help: 'אם דרוש לך סיוע כלשהו, אנחנו תמיד כאן לעזור – ניתן פשוט להשיב למייל זה.',
sign_off: 'בברכה,',
team: 'צוות שירות הלקוחות של Nutriop',
tel_label: 'טל\':',
rtl: true
},
 'zh-CN': {
      name_native: '简体中文',
      subject: '您的 Nutriop 订单 #{order} 已发货',
      badge: '订单已发货',
      heading: '订单 #{order} 已发货',
      greeting: '尊敬的 {firstName}，',
      thanks: '感谢您在 Nutriop Longevity 订购产品。',
      shipped_intro: '我们很高兴地通知您，您的订单 <strong>#{order}</strong> 现已发货，目前正在运送途中。',
      routing: '您的包裹已通过 <strong>{carrier}</strong> 的国际可追踪快递服务寄出，抵达 <strong>{country}</strong> 后将转交当地邮政服务进行最终派送。',
      routing_courier: '您的订单将由 <strong>{carrier}</strong> 直接派送至您在 <strong>{country}</strong> 的地址。您可以随时通过下方的物流追踪链接查看包裹状态。',
      tracking_note_courier: '物流追踪信息通常会在发货后不久显示，并随着 {carrier} 将包裹送达给您而在各个环节持续更新。有时，首次扫描信息可能需要一点时间才能在网上显示。',
      dpd_note: '请注意：对于 DPD 的包裹，您可能需要在 DPD 追踪页面上重新复制并输入物流追踪单号，才能查看最新的物流信息。',
      tracking_label: '物流追踪单号',
      follow_label: '追踪您的包裹：',
      tracking_suffix: '物流追踪',
      delay_1: '请注意，国际物流的追踪状态更新并非总是实时的。由于包裹在跨国运输途中，第一次物理扫描和中转信息显示在网上可能需要一小段时间。',
      delay_2: '当您的包裹抵达您所在国家/地区并进入当地邮政网络后，物流信息通常会更新得更加频繁。',
      closing_thanks: '我们由衷感谢您的耐心与信任，并祝愿您的包裹能够顺利、快速地送达。',
      closing_help: '如果您需要任何协助，我们随时为您效劳，只需直接回复此邮件即可。',
      sign_off: '诚挚的问候，',
      team: '客户服务团队',
      tel_label: '电话：',
      rtl: false
    },
  'zh-TW': {
name_native: '繁體中文 (台灣)',
subject: '您的 Nutriop 訂單 #{order} 已發貨',
badge: '訂單已發貨',
heading: '訂單 #{order} 已在運送途中',
greeting: '親愛的 {firstName} 您好，',
thanks: '感謝您選擇 Nutriop Longevity。',
shipped_intro: '我們很高興地通知您，您的訂單 <strong>#{order}</strong> 現已發貨，正在前往您所在地的途中。',
routing: '您的包裹已透過 <strong>{carrier}</strong> 的國際追蹤遞送服務寄出；包裹抵達 <strong>{country}</strong> 後，將移交給當地的郵政物流進行最終派送。',
routing_courier: '您的訂單將由 <strong>{carrier}</strong> 直接配送至您在 <strong>{country}</strong> 的地址。您可以隨時透過下方的追蹤連結查看包裹狀態。',
tracking_note_courier: '追蹤資訊通常會在出貨後不久顯示，並隨著 {carrier} 將包裹送達給您而在各個階段持續更新。有時首次掃描資訊可能需要一點時間才會在線上顯示。',
dpd_note: '請注意：對於 DPD 的包裹，您可能需要在 DPD 追蹤頁面上重新複製並輸入追蹤單號，才能查看最新的物流資訊。',
tracking_label: '追蹤單號',
follow_label: '追蹤您的包裹狀態：',
tracking_suffix: '追蹤',
delay_1: '請您留意，國際物流的追蹤資訊更新並非即時。在包裹跨國運送期間，通常需要一點時間才能在線上系統顯示首次實體掃描與中轉資訊。',
delay_2: '當包裹抵達您的國家並進入當地郵政系統後，追蹤資訊的更新通常會變得更加頻繁且規律。',
closing_thanks: '我們非常感謝您的耐心與信任，並誠摯祝願您的包裹能順利、快速地送達。',
closing_help: '若您需要任何協助，我們隨時竭誠為您服務，請直接回覆此郵件即可。',
sign_off: '誠摯地，',
team: 'Nutriop 客戶服務團隊',
tel_label: '電話：',
rtl: false
}
  };

  /* "in + country" phrases + routing sentences, fetched from the Worker at load (GET /i18n/in-country).
     Until it arrives (or if it fails) the preview uses the legacy "in {country}" sentence below. */
  var REMOTE_I18N = null;
  function loadRemoteI18n(){
    try {
      fetch(WORKER_URL + '/i18n/in-country').then(function(r){ return r.ok ? r.json() : null; }).then(function(j){
        if(j && j.routing && j.in_country){ REMOTE_I18N = j; if(typeof renderPreview === 'function'){ renderPreview(); } }
      }).catch(function(){});
    } catch(e){}
  }

  var COUNTRY_TO_LANG = {
    'GB': 'en',
    'US': 'en',
    'AU': 'en',
    'CA': 'en',
    'IE': 'en',
    'NZ': 'en',
    'MT': 'en',
    'DE': 'de',
    'AT': 'de',
    'CH': 'de',
    'LI': 'de',
    'FR': 'fr',
    'LU': 'fr',
    'IT': 'it',
    'ES': 'es',
    'NL': 'nl',
    'BE': 'nl',
    'PT': 'pt',
    'PL': 'pl',
    'SE': 'sv',
    'NO': 'no',
    'DK': 'da',
    'FI': 'fi',
    'GR': 'el',
    'CY': 'el',
    'CZ': 'cs',
    'SK': 'sk',
    'HU': 'hu',
    'RO': 'ro',
    'RS': 'en',
    'BG': 'bg',
    'SI': 'sl',
    'HR': 'hr',
    'EE': 'et',
    'LV': 'lv',
    'LT': 'lt',
    'IS': 'is',
    'IL': 'he',
    'TW': 'zh-TW'
  };

  var LANGUAGE_OPTIONS = [
    ['en', 'English'],
    ['de', 'German (Deutsch)'],
    ['fr', 'French (Français)'],
    ['it', 'Italian (Italiano)'],
    ['es', 'Spanish (Español)'],
    ['nl', 'Dutch (Nederlands)'],
    ['pt', 'Portuguese (Português)'],
    ['bg', 'Bulgarian (Български)'],
    ['hr', 'Croatian (Hrvatski)'],
    ['cs', 'Czech (Čeština)'],
    ['da', 'Danish (Dansk)'],
    ['et', 'Estonian (Eesti)'],
    ['fi', 'Finnish (Suomi)'],
    ['el', 'Greek (Ελληνικά)'],
    ['hu', 'Hungarian (Magyar)'],
    ['is', 'Icelandic (Íslenska)'],
    ['lv', 'Latvian (Latviešu)'],
    ['lt', 'Lithuanian (Lietuvių)'],
    ['no', 'Norwegian (Norsk)'],
    ['pl', 'Polish (Polski)'],
    ['ro', 'Romanian (Română)'],
    ['sk', 'Slovak (Slovenčina)'],
    ['sl', 'Slovenian (Slovenščina)'],
    ['sv', 'Swedish (Svenska)'],
    ['he', 'Hebrew (עברית)'],
    ['zh-CN', 'Chinese Simplified (简体中文)'],
    ['zh-TW', 'Chinese Traditional (繁體中文)'],
  ];

  var COUNTRY_NAMES_I18N = {
    'en': {
      'AE': 'United Arab Emirates',
      'GB': 'United Kingdom',
      'US': 'United States',
      'AU': 'Australia',
      'CH': 'Switzerland',
      'DE': 'Germany',
      'AT': 'Austria',
      'BE': 'Belgium',
      'BG': 'Bulgaria',
      'CA': 'Canada',
      'CY': 'Cyprus',
      'CZ': 'Czechia',
      'DK': 'Denmark',
      'EE': 'Estonia',
      'ES': 'Spain',
      'FI': 'Finland',
      'FR': 'France',
      'GR': 'Greece',
      'HR': 'Croatia',
      'HU': 'Hungary',
      'IE': 'Ireland',
      'IL': 'Israel',
      'IS': 'Iceland',
      'IT': 'Italy',
      'LI': 'Liechtenstein',
      'LT': 'Lithuania',
      'LU': 'Luxembourg',
      'LV': 'Latvia',
      'MT': 'Malta',
      'NL': 'Netherlands',
      'NO': 'Norway',
      'NZ': 'New Zealand',
      'PL': 'Poland',
      'PT': 'Portugal',
      'RO': 'Romania',
      'RS': 'Serbia',
      'SE': 'Sweden',
      'SI': 'Slovenia',
      'SK': 'Slovakia',
      'TW': 'Taiwan'
    },
    'de': {
      'GB': 'Vereinigtes Königreich',
      'US': 'USA',
      'AU': 'Australien',
      'CH': 'Schweiz',
      'DE': 'Deutschland',
      'AT': 'Österreich',
      'BE': 'Belgien',
      'BG': 'Bulgarien',
      'CA': 'Kanada',
      'CY': 'Zypern',
      'CZ': 'Tschechien',
      'DK': 'Dänemark',
      'EE': 'Estland',
      'ES': 'Spanien',
      'FI': 'Finnland',
      'FR': 'Frankreich',
      'GR': 'Griechenland',
      'HR': 'Kroatien',
      'HU': 'Ungarn',
      'IE': 'Irland',
      'IL': 'Israel',
      'IS': 'Island',
      'IT': 'Italien',
      'LI': 'Liechtenstein',
      'LT': 'Litauen',
      'LU': 'Luxemburg',
      'LV': 'Lettland',
      'MT': 'Malta',
      'NL': 'Niederlande',
      'NO': 'Norwegen',
      'NZ': 'Neuseeland',
      'PL': 'Polen',
      'PT': 'Portugal',
      'RO': 'Rumänien',
      'RS': 'Serbien',
      'SE': 'Schweden',
      'SI': 'Slowenien',
      'SK': 'Slowakei',
      'TW': 'Taiwan'
    },
    'fr': {
      'GB': 'Royaume-Uni',
      'US': 'États-Unis',
      'AU': 'Australie',
      'CH': 'Suisse',
      'DE': 'Allemagne',
      'AT': 'Autriche',
      'BE': 'Belgique',
      'BG': 'Bulgarie',
      'CA': 'Canada',
      'CY': 'Chypre',
      'CZ': 'Tchéquie',
      'DK': 'Danemark',
      'EE': 'Estonie',
      'ES': 'Espagne',
      'FI': 'Finlande',
      'FR': 'France',
      'GR': 'Grèce',
      'HR': 'Croatie',
      'HU': 'Hongrie',
      'IE': 'Irlande',
      'IL': 'Israël',
      'IS': 'Islande',
      'IT': 'Italie',
      'LI': 'Liechtenstein',
      'LT': 'Lituanie',
      'LU': 'Luxembourg',
      'LV': 'Lettonie',
      'MT': 'Malte',
      'NL': 'Pays-Bas',
      'NO': 'Norvège',
      'NZ': 'Nouvelle-Zélande',
      'PL': 'Pologne',
      'PT': 'Portugal',
      'RO': 'Roumanie',
      'RS': 'Serbie',
      'SE': 'Suède',
      'SI': 'Slovénie',
      'SK': 'Slovaquie',
      'TW': 'Taïwan'
    },
    'it': {
      'GB': 'Regno Unito',
      'US': 'Stati Uniti',
      'AU': 'Australia',
      'CH': 'Svizzera',
      'DE': 'Germania',
      'AT': 'Austria',
      'BE': 'Belgio',
      'BG': 'Bulgaria',
      'CA': 'Canada',
      'CY': 'Cipro',
      'CZ': 'Cechia',
      'DK': 'Danimarca',
      'EE': 'Estonia',
      'ES': 'Spagna',
      'FI': 'Finlandia',
      'FR': 'Francia',
      'GR': 'Grecia',
      'HR': 'Croazia',
      'HU': 'Ungheria',
      'IE': 'Irlanda',
      'IL': 'Israele',
      'IS': 'Islanda',
      'IT': 'Italia',
      'LI': 'Liechtenstein',
      'LT': 'Lituania',
      'LU': 'Lussemburgo',
      'LV': 'Lettonia',
      'MT': 'Malta',
      'NL': 'Paesi Bassi',
      'NO': 'Norvegia',
      'NZ': 'Nuova Zelanda',
      'PL': 'Polonia',
      'PT': 'Portogallo',
      'RO': 'Romania',
      'RS': 'Serbia',
      'SE': 'Svezia',
      'SI': 'Slovenia',
      'SK': 'Slovacchia',
      'TW': 'Taiwan'
    },
    'es': {
      'GB': 'Reino Unido',
      'US': 'Estados Unidos',
      'AU': 'Australia',
      'CH': 'Suiza',
      'DE': 'Alemania',
      'AT': 'Austria',
      'BE': 'Bélgica',
      'BG': 'Bulgaria',
      'CA': 'Canadá',
      'CY': 'Chipre',
      'CZ': 'Chequia',
      'DK': 'Dinamarca',
      'EE': 'Estonia',
      'ES': 'España',
      'FI': 'Finlandia',
      'FR': 'Francia',
      'GR': 'Grecia',
      'HR': 'Croacia',
      'HU': 'Hungría',
      'IE': 'Irlanda',
      'IL': 'Israel',
      'IS': 'Islandia',
      'IT': 'Italia',
      'LI': 'Liechtenstein',
      'LT': 'Lituania',
      'LU': 'Luxemburgo',
      'LV': 'Letonia',
      'MT': 'Malta',
      'NL': 'Países Bajos',
      'NO': 'Noruega',
      'NZ': 'Nueva Zelanda',
      'PL': 'Polonia',
      'PT': 'Portugal',
      'RO': 'Rumania',
      'RS': 'Serbia',
      'SE': 'Suecia',
      'SI': 'Eslovenia',
      'SK': 'Eslovaquia',
      'TW': 'Taiwán'
    },
    'nl': {
      'GB': 'Verenigd Koninkrijk',
      'US': 'Verenigde Staten',
      'AU': 'Australië',
      'CH': 'Zwitserland',
      'DE': 'Duitsland',
      'AT': 'Oostenrijk',
      'BE': 'België',
      'BG': 'Bulgarije',
      'CA': 'Canada',
      'CY': 'Cyprus',
      'CZ': 'Tsjechië',
      'DK': 'Denemarken',
      'EE': 'Estland',
      'ES': 'Spanje',
      'FI': 'Finland',
      'FR': 'Frankrijk',
      'GR': 'Griekenland',
      'HR': 'Kroatië',
      'HU': 'Hongarije',
      'IE': 'Ierland',
      'IL': 'Israël',
      'IS': 'IJsland',
      'IT': 'Italië',
      'LI': 'Liechtenstein',
      'LT': 'Litouwen',
      'LU': 'Luxemburg',
      'LV': 'Letland',
      'MT': 'Malta',
      'NL': 'Nederland',
      'NO': 'Noorwegen',
      'NZ': 'Nieuw-Zeeland',
      'PL': 'Polen',
      'PT': 'Portugal',
      'RO': 'Roemenië',
      'RS': 'Servië',
      'SE': 'Zweden',
      'SI': 'Slovenië',
      'SK': 'Slowakije',
      'TW': 'Taiwan'
    },
    'pt': {
      'GB': 'Reino Unido',
      'US': 'Estados Unidos',
      'AU': 'Austrália',
      'CH': 'Suíça',
      'DE': 'Alemanha',
      'AT': 'Áustria',
      'BE': 'Bélgica',
      'BG': 'Bulgária',
      'CA': 'Canadá',
      'CY': 'Chipre',
      'CZ': 'Chéquia',
      'DK': 'Dinamarca',
      'EE': 'Estónia',
      'ES': 'Espanha',
      'FI': 'Finlândia',
      'FR': 'França',
      'GR': 'Grécia',
      'HR': 'Croácia',
      'HU': 'Hungria',
      'IE': 'Irlanda',
      'IL': 'Israel',
      'IS': 'Islândia',
      'IT': 'Itália',
      'LI': 'Listenstaine',
      'LT': 'Lituânia',
      'LU': 'Luxemburgo',
      'LV': 'Letónia',
      'MT': 'Malta',
      'NL': 'Países Baixos',
      'NO': 'Noruega',
      'NZ': 'Nova Zelândia',
      'PL': 'Polónia',
      'PT': 'Portugal',
      'RO': 'Roménia',
      'RS': 'Sérvia',
      'SE': 'Suécia',
      'SI': 'Eslovénia',
      'SK': 'Eslováquia',
      'TW': 'Taiwan'
    },
    'pl': {
      'GB': 'Wielka Brytania',
      'US': 'Stany Zjednoczone',
      'AU': 'Australia',
      'CH': 'Szwajcaria',
      'DE': 'Niemcy',
      'AT': 'Austria',
      'BE': 'Belgia',
      'BG': 'Bułgaria',
      'CA': 'Kanada',
      'CY': 'Cypr',
      'CZ': 'Czechy',
      'DK': 'Dania',
      'EE': 'Estonia',
      'ES': 'Hiszpania',
      'FI': 'Finlandia',
      'FR': 'Francja',
      'GR': 'Grecja',
      'HR': 'Chorwacja',
      'HU': 'Węgry',
      'IE': 'Irlandia',
      'IL': 'Izrael',
      'IS': 'Islandia',
      'IT': 'Włochy',
      'LI': 'Liechtenstein',
      'LT': 'Litwa',
      'LU': 'Luksemburg',
      'LV': 'Łotwa',
      'MT': 'Malta',
      'NL': 'Holandia',
      'NO': 'Norwegia',
      'NZ': 'Nowa Zelandia',
      'PL': 'Polska',
      'PT': 'Portugalia',
      'RO': 'Rumunia',
      'RS': 'Serbia',
      'SE': 'Szwecja',
      'SI': 'Słowenia',
      'SK': 'Słowacja',
      'TW': 'Tajwan'
    },
    'sv': {
      'GB': 'Storbritannien',
      'US': 'USA',
      'AU': 'Australien',
      'CH': 'Schweiz',
      'DE': 'Tyskland',
      'AT': 'Österrike',
      'BE': 'Belgien',
      'BG': 'Bulgarien',
      'CA': 'Kanada',
      'CY': 'Cypern',
      'CZ': 'Tjeckien',
      'DK': 'Danmark',
      'EE': 'Estland',
      'ES': 'Spanien',
      'FI': 'Finland',
      'FR': 'Frankrike',
      'GR': 'Grekland',
      'HR': 'Kroatien',
      'HU': 'Ungern',
      'IE': 'Irland',
      'IL': 'Israel',
      'IS': 'Island',
      'IT': 'Italien',
      'LI': 'Liechtenstein',
      'LT': 'Litauen',
      'LU': 'Luxemburg',
      'LV': 'Lettland',
      'MT': 'Malta',
      'NL': 'Nederländerna',
      'NO': 'Norge',
      'NZ': 'Nya Zeeland',
      'PL': 'Polen',
      'PT': 'Portugal',
      'RO': 'Rumänien',
      'RS': 'Serbien',
      'SE': 'Sverige',
      'SI': 'Slovenien',
      'SK': 'Slovakien',
      'TW': 'Taiwan'
    },
    'no': {
      'GB': 'Storbritannia',
      'US': 'USA',
      'AU': 'Australia',
      'CH': 'Sveits',
      'DE': 'Tyskland',
      'AT': 'Østerrike',
      'BE': 'Belgia',
      'BG': 'Bulgaria',
      'CA': 'Canada',
      'CY': 'Kypros',
      'CZ': 'Tsjekkia',
      'DK': 'Danmark',
      'EE': 'Estland',
      'ES': 'Spania',
      'FI': 'Finland',
      'FR': 'Frankrike',
      'GR': 'Hellas',
      'HR': 'Kroatia',
      'HU': 'Ungarn',
      'IE': 'Irland',
      'IL': 'Israel',
      'IS': 'Island',
      'IT': 'Italia',
      'LI': 'Liechtenstein',
      'LT': 'Litauen',
      'LU': 'Luxembourg',
      'LV': 'Latvia',
      'MT': 'Malta',
      'NL': 'Nederland',
      'NO': 'Norge',
      'NZ': 'New Zealand',
      'PL': 'Polen',
      'PT': 'Portugal',
      'RO': 'Romania',
      'RS': 'Serbia',
      'SE': 'Sverige',
      'SI': 'Slovenia',
      'SK': 'Slovakia',
      'TW': 'Taiwan'
    },
    'da': {
      'GB': 'Storbritannien',
      'US': 'USA',
      'AU': 'Australien',
      'CH': 'Schweiz',
      'DE': 'Tyskland',
      'AT': 'Østrig',
      'BE': 'Belgien',
      'BG': 'Bulgarien',
      'CA': 'Canada',
      'CY': 'Cypern',
      'CZ': 'Tjekkiet',
      'DK': 'Danmark',
      'EE': 'Estland',
      'ES': 'Spanien',
      'FI': 'Finland',
      'FR': 'Frankrig',
      'GR': 'Grækenland',
      'HR': 'Kroatien',
      'HU': 'Ungarn',
      'IE': 'Irland',
      'IL': 'Israel',
      'IS': 'Island',
      'IT': 'Italien',
      'LI': 'Liechtenstein',
      'LT': 'Litauen',
      'LU': 'Luxembourg',
      'LV': 'Letland',
      'MT': 'Malta',
      'NL': 'Nederlandene',
      'NO': 'Norge',
      'NZ': 'New Zealand',
      'PL': 'Polen',
      'PT': 'Portugal',
      'RO': 'Rumænien',
      'RS': 'Serbien',
      'SE': 'Sverige',
      'SI': 'Slovenien',
      'SK': 'Slovakiet',
      'TW': 'Taiwan'
    },
    'fi': {
      'GB': 'Yhdistynyt kuningaskunta',
      'US': 'Yhdysvallat',
      'AU': 'Australia',
      'CH': 'Sveitsi',
      'DE': 'Saksa',
      'AT': 'Itävalta',
      'BE': 'Belgia',
      'BG': 'Bulgaria',
      'CA': 'Kanada',
      'CY': 'Kypros',
      'CZ': 'Tšekki',
      'DK': 'Tanska',
      'EE': 'Viro',
      'ES': 'Espanja',
      'FI': 'Suomi',
      'FR': 'Ranska',
      'GR': 'Kreikka',
      'HR': 'Kroatia',
      'HU': 'Unkari',
      'IE': 'Irlanti',
      'IL': 'Israel',
      'IS': 'Islanti',
      'IT': 'Italia',
      'LI': 'Liechtenstein',
      'LT': 'Liettua',
      'LU': 'Luxemburg',
      'LV': 'Latvia',
      'MT': 'Malta',
      'NL': 'Alankomaat',
      'NO': 'Norja',
      'NZ': 'Uusi-Seelanti',
      'PL': 'Puola',
      'PT': 'Portugali',
      'RO': 'Romania',
      'RS': 'Serbia',
      'SE': 'Ruotsi',
      'SI': 'Slovenia',
      'SK': 'Slovakia',
      'TW': 'Taiwan'
    },
    'el': {
      'GB': 'Ηνωμένο Βασίλειο',
      'US': 'Ηνωμένες Πολιτείες',
      'AU': 'Αυστραλία',
      'CH': 'Ελβετία',
      'DE': 'Γερμανία',
      'AT': 'Αυστρία',
      'BE': 'Βέλγιο',
      'BG': 'Βουλγαρία',
      'CA': 'Καναδάς',
      'CY': 'Κύπρος',
      'CZ': 'Τσεχία',
      'DK': 'Δανία',
      'EE': 'Εσθονία',
      'ES': 'Ισπανία',
      'FI': 'Φινλανδία',
      'FR': 'Γαλλία',
      'GR': 'Ελλάδα',
      'HR': 'Κροατία',
      'HU': 'Ουγγαρία',
      'IE': 'Ιρλανδία',
      'IL': 'Ισραήλ',
      'IS': 'Ισλανδία',
      'IT': 'Ιταλία',
      'LI': 'Λιχτενστάιν',
      'LT': 'Λιθουανία',
      'LU': 'Λουξεμβούργο',
      'LV': 'Λετονία',
      'MT': 'Μάλτα',
      'NL': 'Κάτω Χώρες',
      'NO': 'Νορβηγία',
      'NZ': 'Νέα Ζηλανδία',
      'PL': 'Πολωνία',
      'PT': 'Πορτογαλία',
      'RO': 'Ρουμανία',
      'RS': 'Σερβία',
      'SE': 'Σουηδία',
      'SI': 'Σλοβενία',
      'SK': 'Σλοβακία',
      'TW': 'Ταϊβάν'
    },
    'cs': {
      'GB': 'Spojené království',
      'US': 'USA',
      'AU': 'Austrálie',
      'CH': 'Švýcarsko',
      'DE': 'Německo',
      'AT': 'Rakousko',
      'BE': 'Belgie',
      'BG': 'Bulharsko',
      'CA': 'Kanada',
      'CY': 'Kypr',
      'CZ': 'Česko',
      'DK': 'Dánsko',
      'EE': 'Estonsko',
      'ES': 'Španělsko',
      'FI': 'Finsko',
      'FR': 'Francie',
      'GR': 'Řecko',
      'HR': 'Chorvatsko',
      'HU': 'Maďarsko',
      'IE': 'Irsko',
      'IL': 'Izrael',
      'IS': 'Island',
      'IT': 'Itálie',
      'LI': 'Lichtenštejnsko',
      'LT': 'Litva',
      'LU': 'Lucembursko',
      'LV': 'Lotyšsko',
      'MT': 'Malta',
      'NL': 'Nizozemsko',
      'NO': 'Norsko',
      'NZ': 'Nový Zéland',
      'PL': 'Polsko',
      'PT': 'Portugalsko',
      'RO': 'Rumunsko',
      'RS': 'Srbsko',
      'SE': 'Švédsko',
      'SI': 'Slovinsko',
      'SK': 'Slovensko',
      'TW': 'Tchaj-wan'
    },
    'sk': {
      'GB': 'Spojené kráľovstvo',
      'US': 'USA',
      'AU': 'Austrália',
      'CH': 'Švajčiarsko',
      'DE': 'Nemecko',
      'AT': 'Rakúsko',
      'BE': 'Belgicko',
      'BG': 'Bulharsko',
      'CA': 'Kanada',
      'CY': 'Cyprus',
      'CZ': 'Česko',
      'DK': 'Dánsko',
      'EE': 'Estónsko',
      'ES': 'Španielsko',
      'FI': 'Fínsko',
      'FR': 'Francúzsko',
      'GR': 'Grécko',
      'HR': 'Chorvátsko',
      'HU': 'Maďarsko',
      'IE': 'Írsko',
      'IL': 'Izrael',
      'IS': 'Island',
      'IT': 'Taliansko',
      'LI': 'Lichtenštajnsko',
      'LT': 'Litva',
      'LU': 'Luxembursko',
      'LV': 'Lotyšsko',
      'MT': 'Malta',
      'NL': 'Holandsko',
      'NO': 'Nórsko',
      'NZ': 'Nový Zéland',
      'PL': 'Poľsko',
      'PT': 'Portugalsko',
      'RO': 'Rumunsko',
      'RS': 'Srbsko',
      'SE': 'Švédsko',
      'SI': 'Slovinsko',
      'SK': 'Slovensko',
      'TW': 'Taiwan'
    },
    'hu': {
      'GB': 'Egyesült Királyság',
      'US': 'Egyesült Államok',
      'AU': 'Ausztrália',
      'CH': 'Svájc',
      'DE': 'Németország',
      'AT': 'Ausztria',
      'BE': 'Belgium',
      'BG': 'Bulgária',
      'CA': 'Kanada',
      'CY': 'Ciprus',
      'CZ': 'Csehország',
      'DK': 'Dánia',
      'EE': 'Észtország',
      'ES': 'Spanyolország',
      'FI': 'Finnország',
      'FR': 'Franciaország',
      'GR': 'Görögország',
      'HR': 'Horvátország',
      'HU': 'Magyarország',
      'IE': 'Írország',
      'IL': 'Izrael',
      'IS': 'Izland',
      'IT': 'Olaszország',
      'LI': 'Liechtenstein',
      'LT': 'Litvánia',
      'LU': 'Luxemburg',
      'LV': 'Lettország',
      'MT': 'Málta',
      'NL': 'Hollandia',
      'NO': 'Norvégia',
      'NZ': 'Új-Zéland',
      'PL': 'Lengyelország',
      'PT': 'Portugália',
      'RO': 'Románia',
      'RS': 'Szerbia',
      'SE': 'Svédország',
      'SI': 'Szlovénia',
      'SK': 'Szlovákia',
      'TW': 'Tajvan'
    },
    'ro': {
      'GB': 'Regatul Unit',
      'US': 'Statele Unite',
      'AU': 'Australia',
      'CH': 'Elveția',
      'DE': 'Germania',
      'AT': 'Austria',
      'BE': 'Belgia',
      'BG': 'Bulgaria',
      'CA': 'Canada',
      'CY': 'Cipru',
      'CZ': 'Cehia',
      'DK': 'Danemarca',
      'EE': 'Estonia',
      'ES': 'Spania',
      'FI': 'Finlanda',
      'FR': 'Franța',
      'GR': 'Grecia',
      'HR': 'Croația',
      'HU': 'Ungaria',
      'IE': 'Irlanda',
      'IL': 'Israel',
      'IS': 'Islanda',
      'IT': 'Italia',
      'LI': 'Liechtenstein',
      'LT': 'Lituania',
      'LU': 'Luxemburg',
      'LV': 'Letonia',
      'MT': 'Malta',
      'NL': 'Țările de Jos',
      'NO': 'Norvegia',
      'NZ': 'Noua Zeelandă',
      'PL': 'Polonia',
      'PT': 'Portugalia',
      'RO': 'România',
      'RS': 'Serbia',
      'SE': 'Suedia',
      'SI': 'Slovenia',
      'SK': 'Slovacia',
      'TW': 'Taiwan'
    },
    'bg': {
      'GB': 'Обединеното кралство',
      'US': 'Съединените щати',
      'AU': 'Австралия',
      'CH': 'Швейцария',
      'DE': 'Германия',
      'AT': 'Австрия',
      'BE': 'Белгия',
      'BG': 'България',
      'CA': 'Канада',
      'CY': 'Кипър',
      'CZ': 'Чехия',
      'DK': 'Дания',
      'EE': 'Естония',
      'ES': 'Испания',
      'FI': 'Финландия',
      'FR': 'Франция',
      'GR': 'Гърция',
      'HR': 'Хърватия',
      'HU': 'Унгария',
      'IE': 'Ирландия',
      'IL': 'Израел',
      'IS': 'Исландия',
      'IT': 'Италия',
      'LI': 'Лихтенщайн',
      'LT': 'Литва',
      'LU': 'Люксембург',
      'LV': 'Латвия',
      'MT': 'Малта',
      'NL': 'Нидерландия',
      'NO': 'Норвегия',
      'NZ': 'Нова Зеландия',
      'PL': 'Полша',
      'PT': 'Португалия',
      'RO': 'Румъния',
      'RS': 'Сърбия',
      'SE': 'Швеция',
      'SI': 'Словения',
      'SK': 'Словакия',
      'TW': 'Тайван'
    },
    'sl': {
      'GB': 'Združeno kraljestvo',
      'US': 'Združene države Amerike',
      'AU': 'Avstralija',
      'CH': 'Švica',
      'DE': 'Nemčija',
      'AT': 'Avstrija',
      'BE': 'Belgija',
      'BG': 'Bolgarija',
      'CA': 'Kanada',
      'CY': 'Ciper',
      'CZ': 'Češka',
      'DK': 'Danska',
      'EE': 'Estonija',
      'ES': 'Španija',
      'FI': 'Finska',
      'FR': 'Francija',
      'GR': 'Grčija',
      'HR': 'Hrvaška',
      'HU': 'Madžarska',
      'IE': 'Irska',
      'IL': 'Izrael',
      'IS': 'Islandija',
      'IT': 'Italija',
      'LI': 'Lihtenštajn',
      'LT': 'Litva',
      'LU': 'Luksemburg',
      'LV': 'Latvija',
      'MT': 'Malta',
      'NL': 'Nizozemska',
      'NO': 'Norveška',
      'NZ': 'Nova Zelandija',
      'PL': 'Poljska',
      'PT': 'Portugalska',
      'RO': 'Romunija',
      'RS': 'Srbija',
      'SE': 'Švedska',
      'SI': 'Slovenija',
      'SK': 'Slovaška',
      'TW': 'Tajvan'
    },
    'hr': {
      'GB': 'Ujedinjeno Kraljevstvo',
      'US': 'Sjedinjene Američke Države',
      'AU': 'Australija',
      'CH': 'Švicarska',
      'DE': 'Njemačka',
      'AT': 'Austrija',
      'BE': 'Belgija',
      'BG': 'Bugarska',
      'CA': 'Kanada',
      'CY': 'Cipar',
      'CZ': 'Češka',
      'DK': 'Danska',
      'EE': 'Estonija',
      'ES': 'Španjolska',
      'FI': 'Finska',
      'FR': 'Francuska',
      'GR': 'Grčka',
      'HR': 'Hrvatska',
      'HU': 'Mađarska',
      'IE': 'Irska',
      'IL': 'Izrael',
      'IS': 'Island',
      'IT': 'Italija',
      'LI': 'Lihtenštajn',
      'LT': 'Litva',
      'LU': 'Luksemburg',
      'LV': 'Latvija',
      'MT': 'Malta',
      'NL': 'Nizozemska',
      'NO': 'Norveška',
      'NZ': 'Novi Zeland',
      'PL': 'Poljska',
      'PT': 'Portugal',
      'RO': 'Rumunjska',
      'RS': 'Srbija',
      'SE': 'Švedska',
      'SI': 'Slovenija',
      'SK': 'Slovačka',
      'TW': 'Tajvan'
    },
    'et': {
      'GB': 'Suurbritannia',
      'US': 'Ameerika Ühendriigid',
      'AU': 'Austraalia',
      'CH': 'Šveits',
      'DE': 'Saksamaa',
      'AT': 'Austria',
      'BE': 'Belgia',
      'BG': 'Bulgaaria',
      'CA': 'Kanada',
      'CY': 'Küpros',
      'CZ': 'Tšehhi',
      'DK': 'Taani',
      'EE': 'Eesti',
      'ES': 'Hispaania',
      'FI': 'Soome',
      'FR': 'Prantsusmaa',
      'GR': 'Kreeka',
      'HR': 'Horvaatia',
      'HU': 'Ungari',
      'IE': 'Iirimaa',
      'IL': 'Iisrael',
      'IS': 'Island',
      'IT': 'Itaalia',
      'LI': 'Liechtenstein',
      'LT': 'Leedu',
      'LU': 'Luksemburg',
      'LV': 'Läti',
      'MT': 'Malta',
      'NL': 'Holland',
      'NO': 'Norra',
      'NZ': 'Uus-Meremaa',
      'PL': 'Poola',
      'PT': 'Portugal',
      'RO': 'Rumeenia',
      'RS': 'Serbia',
      'SE': 'Rootsi',
      'SI': 'Sloveenia',
      'SK': 'Slovakkia',
      'TW': 'Taiwan'
    },
    'lv': {
      'GB': 'Apvienotā Karaliste',
      'US': 'Amerikas Savienotās Valstis',
      'AU': 'Austrālija',
      'CH': 'Šveice',
      'DE': 'Vācija',
      'AT': 'Austrija',
      'BE': 'Beļģija',
      'BG': 'Bulgārija',
      'CA': 'Kanāda',
      'CY': 'Kipra',
      'CZ': 'Čehija',
      'DK': 'Dānija',
      'EE': 'Igaunija',
      'ES': 'Spānija',
      'FI': 'Somija',
      'FR': 'Francija',
      'GR': 'Grieķija',
      'HR': 'Horvātija',
      'HU': 'Ungārija',
      'IE': 'Īrija',
      'IL': 'Izraēla',
      'IS': 'Īslande',
      'IT': 'Itālija',
      'LI': 'Lihtenšteina',
      'LT': 'Lietuva',
      'LU': 'Luksemburga',
      'LV': 'Latvija',
      'MT': 'Malta',
      'NL': 'Nīderlande',
      'NO': 'Norvēģija',
      'NZ': 'Jaunzēlande',
      'PL': 'Polija',
      'PT': 'Portugāle',
      'RO': 'Rumānija',
      'RS': 'Serbija',
      'SE': 'Zviedrija',
      'SI': 'Slovēnija',
      'SK': 'Slovākija',
      'TW': 'Taivāna'
    },
    'lt': {
      'GB': 'Jungtinė Karalystė',
      'US': 'Jungtinės Amerikos Valstijos',
      'AU': 'Australija',
      'CH': 'Šveicarija',
      'DE': 'Vokietija',
      'AT': 'Austrija',
      'BE': 'Belgija',
      'BG': 'Bulgarija',
      'CA': 'Kanada',
      'CY': 'Kipras',
      'CZ': 'Čekija',
      'DK': 'Danija',
      'EE': 'Estija',
      'ES': 'Ispanija',
      'FI': 'Suomija',
      'FR': 'Prancūzija',
      'GR': 'Graikija',
      'HR': 'Kroatija',
      'HU': 'Vengrija',
      'IE': 'Airija',
      'IL': 'Izraelis',
      'IS': 'Islandija',
      'IT': 'Italija',
      'LI': 'Lichtenšteinas',
      'LT': 'Lietuva',
      'LU': 'Liuksemburgas',
      'LV': 'Latvija',
      'MT': 'Malta',
      'NL': 'Nyderlandai',
      'NO': 'Norvegija',
      'NZ': 'Naujoji Zelandija',
      'PL': 'Lenkija',
      'PT': 'Portugalija',
      'RO': 'Rumunija',
      'RS': 'Serbija',
      'SE': 'Švedija',
      'SI': 'Slovėnija',
      'SK': 'Slovakija',
      'TW': 'Taivanas'
    },
    'is': {
      'GB': 'Bretland',
      'US': 'Bandaríkin',
      'AU': 'Ástralía',
      'CH': 'Sviss',
      'DE': 'Þýskaland',
      'AT': 'Austurríki',
      'BE': 'Belgía',
      'BG': 'Búlgaría',
      'CA': 'Kanada',
      'CY': 'Kýpur',
      'CZ': 'Tékkland',
      'DK': 'Danmörk',
      'EE': 'Eistland',
      'ES': 'Spánn',
      'FI': 'Finnland',
      'FR': 'Frakkland',
      'GR': 'Grikkland',
      'HR': 'Króatía',
      'HU': 'Ungverjaland',
      'IE': 'Írland',
      'IL': 'Ísrael',
      'IS': 'Ísland',
      'IT': 'Ítalía',
      'LI': 'Liechtenstein',
      'LT': 'Litháen',
      'LU': 'Lúxemborg',
      'LV': 'Lettland',
      'MT': 'Malta',
      'NL': 'Holland',
      'NO': 'Noregur',
      'NZ': 'Nýja-Sjáland',
      'PL': 'Pólland',
      'PT': 'Portúgal',
      'RO': 'Rúmenía',
      'RS': 'Serbía',
      'SE': 'Svíþjóð',
      'SI': 'Slóvenía',
      'SK': 'Slóvakía',
      'TW': 'Taívan'
    },
    'he': {
      'GB': 'בריטניה',
      'US': 'ארצות הברית',
      'AU': 'אוסטרליה',
      'CH': 'שווייץ',
      'DE': 'גרמניה',
      'AT': 'אוסטריה',
      'BE': 'בלגיה',
      'BG': 'בולגריה',
      'CA': 'קנדה',
      'CY': 'קפריסין',
      'CZ': 'צ\'כיה',
      'DK': 'דנמרק',
      'EE': 'אסטוניה',
      'ES': 'ספרד',
      'FI': 'פינלנד',
      'FR': 'צרפת',
      'GR': 'יוון',
      'HR': 'קרואטיה',
      'HU': 'הונגריה',
      'IE': 'אירלנד',
      'IL': 'ישראל',
      'IS': 'איסלנד',
      'IT': 'איטליה',
      'LI': 'ליכטנשטיין',
      'LT': 'ליטא',
      'LU': 'לוקסמבורג',
      'LV': 'לטביה',
      'MT': 'מלטה',
      'NL': 'הולנד',
      'NO': 'נורווגיה',
      'NZ': 'ניו זילנד',
      'PL': 'פולין',
      'PT': 'פורטוגל',
      'RO': 'רומניה',
      'RS': 'סרביה',
      'SE': 'שוודיה',
      'SI': 'סלובניה',
      'SK': 'סלובקיה',
      'TW': 'טייוואן'
    },
    'zh-CN': {
      'GB': '英国',
      'US': '美国',
      'AU': '澳大利亚',
      'CH': '瑞士',
      'DE': '德国',
      'AT': '奥地利',
      'BE': '比利时',
      'BG': '保加利亚',
      'CA': '加拿大',
      'CY': '塞浦路斯',
      'CZ': '捷克',
      'DK': '丹麦',
      'EE': '爱沙尼亚',
      'ES': '西班牙',
      'FI': '芬兰',
      'FR': '法国',
      'GR': '希腊',
      'HR': '克罗地亚',
      'HU': '匈牙利',
      'IE': '爱尔兰',
      'IL': '以色列',
      'IS': '冰岛',
      'IT': '意大利',
      'LI': '列支敦士登',
      'LT': '立陶宛',
      'LU': '卢森堡',
      'LV': '拉脱维亚',
      'MT': '马耳他',
      'NL': '荷兰',
      'NO': '挪威',
      'NZ': '新西兰',
      'PL': '波兰',
      'PT': '葡萄牙',
      'RO': '罗马尼亚',
      'RS': '塞尔维亚',
      'SE': '瑞典',
      'SI': '斯洛文尼亚',
      'SK': '斯洛伐克',
      'TW': '台湾'
    },
    'zh-TW': {
      'GB': '英國',
      'US': '美國',
      'AU': '澳洲',
      'CH': '瑞士',
      'DE': '德國',
      'AT': '奧地利',
      'BE': '比利時',
      'BG': '保加利亞',
      'CA': '加拿大',
      'CY': '賽普勒斯',
      'CZ': '捷克',
      'DK': '丹麥',
      'EE': '愛沙尼亞',
      'ES': '西班牙',
      'FI': '芬蘭',
      'FR': '法國',
      'GR': '希臘',
      'HR': '克羅埃西亞',
      'HU': '匈牙利',
      'IE': '愛爾蘭',
      'IL': '以色列',
      'IS': '冰島',
      'IT': '義大利',
      'LI': '列支敦斯登',
      'LT': '立陶宛',
      'LU': '盧森堡',
      'LV': '拉脫維亞',
      'MT': '馬爾他',
      'NL': '荷蘭',
      'NO': '挪威',
      'NZ': '紐西蘭',
      'PL': '波蘭',
      'PT': '葡萄牙',
      'RO': '羅馬尼亞',
      'RS': '塞爾維亞',
      'SE': '瑞典',
      'SI': '斯洛維尼亞',
      'SK': '斯洛伐克',
      'TW': '台灣'
    }
  };

    /* =========================================================
       DOM HELPERS
       ========================================================= */
    function $(id){ return document.getElementById(id); }
    function escapeHtml(s){
      return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
        return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
      });
    }

    /* =========================================================
       AUTH GATE
       ========================================================= */
    var gate     = $('gate');
    var app      = $('app');
    var gateIn   = $('gate-input');
    var gateBtn  = $('gate-btn');
    var gateErr  = $('gate-err');

    function unlock(passphrase){
      if(!passphrase){ gateErr.textContent = 'Please enter the passphrase.'; return; }
      sessionStorage.setItem('nutriop_staff_pp', passphrase);
      gate.style.display = 'none';
      app.classList.add('is-active');
      gateErr.textContent = '';
      initApp();
    }

    function lock(){
      sessionStorage.removeItem('nutriop_staff_pp');
      location.reload();
    }

    gateBtn.addEventListener('click', function(){ unlock(gateIn.value.trim()); });
    gateIn.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ unlock(gateIn.value.trim()); } });

    // Auto-unlock if passphrase already in sessionStorage
    var existing = sessionStorage.getItem('nutriop_staff_pp');
    if(existing){
      gate.style.display = 'none';
      app.classList.add('is-active');
      initApp();
    }

    /* =========================================================
       APP INIT
       ========================================================= */
    function initApp(){
      // Populate country dropdown
      var sel = $('countryCode');
      COUNTRIES.forEach(function(c){
        var opt = document.createElement('option');
        opt.value = c[0];
        opt.textContent = c[1];
        if(!c[0]){ opt.disabled = true; opt.style.color = '#9ca3af'; }
        sel.appendChild(opt);
      });

      // Populate language dropdown
      var langSel = $('languageCode');
      LANGUAGE_OPTIONS.forEach(function(opt){
        var o = document.createElement('option');
        o.value = opt[0];
        o.textContent = opt[1];
        langSel.appendChild(o);
      });
      langSel.value = 'en'; // default

      // Restore rep name from localStorage
      var savedRep = localStorage.getItem('nutriop_staff_rep') || '';
      $('repName').value = savedRep;
      updateRepPill();

      // Wire events
      ['firstName','customerEmail','orderNumber','originCarrier','trackingNumber',
       'originTrackingLink','countryCode','manualCountryName','localCarrier','localTrackingLink','repName',
       'languageCode']
        .forEach(function(id){
          var el = $(id);
          el.addEventListener('input', onAnyChange);
          el.addEventListener('change', onAnyChange);
        });

      $('originCarrier').addEventListener('change', onCarrierChange);
      $('trackingNumber').addEventListener('input', autoFillOriginLink);
      $('trackingNumber').addEventListener('input', autoFillLocalLink);
      if($('postalCode')){ $('postalCode').addEventListener('input', function(){ delete $('originTrackingLink').dataset.userEdited; autoFillOriginLink(); onAnyChange(); }); }
      $('countryCode').addEventListener('change', onCountryChange);
      $('languageCode').addEventListener('change', function(){
        $('languageCode').dataset.userEdited = '1';
      });
      $('repName').addEventListener('input', function(){
        localStorage.setItem('nutriop_staff_rep', $('repName').value.trim());
        updateRepPill();
      });

      $('logout-btn').addEventListener('click', lock);
      $('reset-btn').addEventListener('click', resetForm);
      $('send-btn').addEventListener('click', sendEmail);
      loadRemoteI18n();

      // --- Shipping automation hand-off: pre-fill from the alert link (?order=&fn=&email=&tn=&cc=&carrier=&lang=) ---
      window.__nutriopForceSend = function(){ window.__nutriopForce = true; sendEmail(); };
      (function prefillFromUrl(){
        try {
          var qs = new URLSearchParams(window.location.search);
          if(!qs.has('order') && !qs.has('tn')) return;
          var setVal = function(id, v){
            var el = $(id); if(!el || v == null || v === '') return;
            el.value = v;
            el.dispatchEvent(new Event('input', { bubbles: true }));
            el.dispatchEvent(new Event('change', { bubbles: true }));
          };
          setVal('orderNumber',    qs.get('order'));
          setVal('firstName',      qs.get('fn'));
          setVal('customerEmail',  qs.get('email'));
          setVal('originCarrier',  qs.get('carrier'));
          setVal('countryCode',    qs.get('cc'));
          setVal('trackingNumber', qs.get('tn'));
          if(qs.get('lang')){ setVal('languageCode', qs.get('lang')); $('languageCode').dataset.userEdited = '1'; }
        } catch(e){ /* best-effort */ }
      })();

      toggleManualCountry();
      applyCarrierMode();
      renderPreview();
    }

    function updateRepPill(){
      var name = $('repName').value.trim();
      $('rep-pill').textContent = name ? ('Signed in as ' + name) : '';
    }

    function toggleManualCountry(){
      var manual = $('countryCode').value === '__';
      var row = $('manualCountryRow');
      if(row){ row.style.display = manual ? '' : 'none'; }
    }

    function onCountryChange(){
      toggleManualCountry();
      var code = $('countryCode').value;
      if(code && code !== '__' && COUNTRY_DATA_BY_CODE[code]){
        var d = COUNTRY_DATA_BY_CODE[code];
        // Only overwrite if user hasn't already typed something custom
        if(!$('localCarrier').dataset.userEdited){
          $('localCarrier').value = d.carrier;
        }
        // Auto-select language unless staff manually picked one
        if(!$('languageCode').dataset.userEdited){
          var langCode = getLanguageForCountry(code);
          $('languageCode').value = langCode;
        }
      }
      applyCarrierMode();
      delete $('originTrackingLink').dataset.userEdited;
      autoFillOriginLink();
      autoFillLocalLink();
      onAnyChange();
    }

    $('localCarrier').addEventListener('input', function(){
      $('localCarrier').dataset.userEdited = '1';
    });
    $('originTrackingLink').addEventListener('input', function(){
      $('originTrackingLink').dataset.userEdited = '1';
    });
    $('localTrackingLink').addEventListener('input', function(){
      $('localTrackingLink').dataset.userEdited = '1';
    });

    function autoFillOriginLink(){
      if($('originTrackingLink').dataset.userEdited) return;
      var carrier = $('originCarrier').value;
      var tn = $('trackingNumber').value.trim();
      var cc = $('countryCode').value;
      var tpl = (INTL_TRACK_TEMPLATES[carrier] && cc && cc !== '__' && !isDomestic(carrier, cc)) ? INTL_TRACK_TEMPLATES[carrier] : TRACK_TEMPLATES[carrier];
      if(tpl && tpl.indexOf('{postcode}') > -1){
        var pcEl = $('postalCode');
        var pc = pcEl ? pcEl.value.replace(/\s+/g, '').toUpperCase() : '';
        tpl = pc ? tpl.replace('{postcode}', encodeURIComponent(pc)) : tpl.replace('/{postcode}', '');
      }
      if(tpl && tn){
        $('originTrackingLink').value = tpl.replace('{tracking}', encodeURIComponent(tn));
      } else if(tpl && !tn){
        $('originTrackingLink').value = '';
      }
    }

    function autoFillLocalLink(){
      if($('localTrackingLink').dataset.userEdited) return;
      var code = $('countryCode').value;
      var tn = $('trackingNumber').value.trim();
      if(code && code !== '__' && COUNTRY_DATA_BY_CODE[code]){
        var url = COUNTRY_DATA_BY_CODE[code].url;
        if(url){
          $('localTrackingLink').value = url.indexOf('{tracking}') > -1
            ? url.replace('{tracking}', encodeURIComponent(tn))
            : url;
        }
      }
    }

    function applyCarrierMode(){
      var courier = isDirect($('originCarrier').value, $('countryCode').value);
      var dest = $('postalDestFields');
      if(dest){ dest.style.display = courier ? 'none' : ''; }
      var cardTitle = $('originCardTitle');
      if(cardTitle){ cardTitle.textContent = courier ? 'Carrier' : 'Origin (Outbound Carrier)'; }
      var linkLabel = $('originLinkLabel');
      if(linkLabel){ linkLabel.innerHTML = (courier ? 'Tracking link' : 'Origin tracking link') + ' <span class="req">*</span>'; }
    }

    function onCarrierChange(){
      applyCarrierMode();
      if(isCourier($('originCarrier').value)){
        $('localCarrier').value = '';
        delete $('localCarrier').dataset.userEdited;
        $('localTrackingLink').value = '';
        delete $('localTrackingLink').dataset.userEdited;
      }
      delete $('originTrackingLink').dataset.userEdited;
      autoFillOriginLink();
      onAnyChange();
    }

    function onAnyChange(){
      renderPreview();
    }

    function getFormData(){
      var code = $('countryCode').value;
      var countryName;
      if(code === '__'){
        countryName = $('manualCountryName').value.trim();
      } else if(code && code !== '__'){
        countryName = COUNTRY_NAME_BY_CODE[code] || code;
      } else {
        countryName = '';
      }
      return {
        firstName:          $('firstName').value.trim(),
        customerEmail:      $('customerEmail').value.trim(),
        orderNumber:        $('orderNumber').value.trim(),
        originCarrier:      $('originCarrier').value,
        trackingNumber:     $('trackingNumber').value.trim(),
        originTrackingLink: $('originTrackingLink').value.trim(),
        country:            countryName,
        countryCode:        (code && code !== '__') ? code : '',
        localCarrier:       $('localCarrier').value.trim(),
        localTrackingLink:  $('localTrackingLink').value.trim(),
        repName:            $('repName').value.trim(),
        postalCode:         ($('postalCode') ? $('postalCode').value.trim() : ''),
        language:           $('languageCode').value || 'en'
      };
    }

    /* =========================================================
       I18N HELPERS
       ========================================================= */
    function getLanguageForCountry(code){
      return COUNTRY_TO_LANG[code] || 'en';
    }

    function getLocalizedCountryName(code, lang, fallback){
      // Look up the country name in the customer's language.
      // Falls back to the English name passed in, or the code itself.
      if(code && COUNTRY_NAMES_I18N[lang] && COUNTRY_NAMES_I18N[lang][code]){
        return COUNTRY_NAMES_I18N[lang][code];
      }
      if(code && COUNTRY_NAMES_I18N['en'] && COUNTRY_NAMES_I18N['en'][code]){
        return COUNTRY_NAMES_I18N['en'][code];
      }
      return fallback || code || '-';
    }

    function fillTemplate(tpl, vars){
      return String(tpl).replace(/\{(\w+)\}/g, function(_, k){
        return (vars[k] != null) ? vars[k] : '';
      });
    }

    /* =========================================================
       EMAIL HTML - must match the Worker's template exactly so
       what staff see in preview is what the customer receives.
       ========================================================= */
    function buildEmailHtml(d, lang){
      var T = TRANSLATIONS[lang] || TRANSLATIONS['en'];
      var e = escapeHtml;
      var orderNum    = d.orderNumber || '-';
      var firstName   = d.firstName || '-';
      var carrier     = d.originCarrier || '-';
      var localizedCountry = getLocalizedCountryName(d.countryCode, lang, d.country) || '-';
      var tn          = d.trackingNumber || '-';
      var originLink  = d.originTrackingLink || '#';
      var localCarrier= d.localCarrier || '-';
      var localLink   = d.localTrackingLink || '#';
      var rep         = d.repName || '-';
      var dirAttr     = T.rtl ? 'rtl' : 'ltr';
      var textAlign   = T.rtl ? 'right' : 'left';

      // String substitutions for placeholders. firstName/order/etc are
      // already HTML-escaped where they get rendered as plain text.
      // For the strong-tag content in shipped_intro/routing we pre-escape.
      var vars = {
        order:     e(orderNum),
        firstName: e(firstName),
        carrier:   e(carrier),
        country:   e(localizedCountry)
      };

      var heading       = fillTemplate(T.heading, vars);
      var greeting      = fillTemplate(T.greeting, vars);
      var shipped_intro = fillTemplate(T.shipped_intro, vars);
      var courier = isDirect(d.originCarrier, d.countryCode);
      var isDpd = d.originCarrier === 'DPD';
      var isRoyalMail = /royal\s*mail/i.test(String(d.localCarrier || '')) || /royal\s*mail/i.test(String(d.originCarrier || ''));
      var routingKey = courier ? 'routing_courier' : 'routing';
      var remoteTpl = REMOTE_I18N && REMOTE_I18N.routing[lang] && REMOTE_I18N.routing[lang][routingKey];
      var remotePhrase = REMOTE_I18N && REMOTE_I18N.in_country[lang] && REMOTE_I18N.in_country[lang][d.countryCode];
      var routing = (remoteTpl && remotePhrase)
        ? fillTemplate(remoteTpl, Object.assign({}, vars, { in_country: e(remotePhrase) }))
        : fillTemplate(T[routingKey], vars);

      var trackingLinksHtml = courier
        ? '<div style="margin:6px 0;"><a href="' + e(originLink) + '" style="color:#FF6B6B;text-decoration:none;font-weight:600;font-size:14px;">&rarr; ' + e(carrier) + ' ' + e(T.tracking_suffix) + '</a></div>'
        : '<div style="margin:6px 0;"><a href="' + e(originLink) + '" style="color:#FF6B6B;text-decoration:none;font-weight:600;font-size:14px;">&rarr; ' + e(carrier) + ' ' + e(T.tracking_suffix) + '</a></div>' +
          '<div style="margin:6px 0;"><a href="' + e(localLink) + '" style="color:#FF6B6B;text-decoration:none;font-weight:600;font-size:14px;">&rarr; ' + e(localCarrier) + ' ' + e(T.tracking_suffix) + '</a></div>';

      var notesHtml = courier
        ? '<p style="font-size:15px;color:#4b5563;margin:25px 0 ' + (isDpd ? '15px' : '25px') + ';">' + fillTemplate(T.tracking_note_courier, vars) + '</p>' + (isDpd ? '<p style="font-size:15px;color:#4b5563;margin:0 0 25px;">' + e(T.dpd_note) + '</p>' : '')
        : '<p style="font-size:15px;color:#4b5563;margin:25px 0 15px;">' + e(T.delay_1) + '</p>' +
          '<p style="font-size:15px;color:#4b5563;margin:0 0 25px;">' + e(T.delay_2) + '</p>';

      return '<!DOCTYPE html><html dir="' + dirAttr + '"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>' + e(fillTemplate(T.subject, vars)) + '</title></head>' +
'<body style="margin:0;padding:0;background:#f5f5f5;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;direction:' + dirAttr + ';text-align:' + textAlign + ';">' +
'<div style="max-width:600px;margin:0 auto;background:#ffffff;">' +

/* HEADER - navy + logo */
'<div style="background:#0A2540;padding:32px 25px;text-align:center;">' +
  '<img src="https://cdn.shopify.com/s/files/1/0091/2008/8124/files/official-nutriop-longevity-LOGO2023_print.png?v=1778766436" alt="Nutriop Longevity" width="220" style="display:inline-block;max-width:220px;width:220px;height:auto;border:0;" />' +
'</div>' +

'<div style="background:#ffffff;padding:32px 25px 8px;text-align:center;">' +
  '<div style="display:inline-block;padding:6px 14px;background:#fff3f3;color:#FF6B6B;font-size:11px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;border-radius:20px;">' + e(T.badge) + '</div>' +
  '<h1 style="font-size:24px;margin:18px 0 0;color:#1a1a1a;font-weight:700;line-height:1.3;">' + heading + '</h1>' +
'</div>' +

'<div style="background:#ffffff;padding:25px 32px 5px;color:#1a1a1a;line-height:1.65;">' +
  '<p style="font-size:16px;margin:18px 0;">' + greeting + '</p>' +
  '<p style="font-size:16px;margin:0 0 18px;">' + e(T.thanks) + '</p>' +
  '<p style="font-size:16px;margin:0 0 18px;">' + shipped_intro + '</p>' +
  '<p style="font-size:16px;margin:0 0 25px;">' + routing + '</p>' +

  '<div style="background:#f9fafb;border-' + (T.rtl ? 'right' : 'left') + ':4px solid #FF6B6B;border-radius:6px;padding:22px;margin:25px 0;text-align:' + textAlign + ';">' +
    '<div style="font-size:11px;color:#6b7280;text-transform:uppercase;letter-spacing:1.5px;font-weight:700;margin-bottom:6px;">' + e(T.tracking_label) + '</div>' +
    '<div style="font-size:18px;font-weight:700;color:#1a1a1a;letter-spacing:0.5px;margin-bottom:20px;font-family:SF Mono,Menlo,Monaco,Consolas,monospace;word-break:break-all;">' + e(tn) + '</div>' +
    '<div style="font-size:13px;color:#374151;margin-bottom:10px;font-weight:600;">' + e(T.follow_label) + '</div>' +
    trackingLinksHtml +
  '</div>' +

  notesHtml +
  '<p style="font-size:15px;margin:0 0 18px;">' + e(T.closing_thanks) + '</p>' +
  '<p style="font-size:15px;margin:0 0 30px;">' + e(T.closing_help) + '</p>' +

  '<p style="font-size:15px;margin:0 0 4px;">' + e(T.sign_off) + '</p>' +
  '<p style="font-size:16px;margin:0 0 2px;font-weight:600;color:#1a1a1a;">' + e(rep) + '</p>' +
  '<p style="font-size:14px;color:#6b7280;margin:0;">' + e(T.team) + '</p>' +
  '<p style="font-size:14px;color:#6b7280;margin:0 0 25px;">Nutriop Longevity</p>' +
'</div>' +

'<div style="background:#f8f9fa;padding:22px 25px;text-align:center;border-top:1px solid #e5e7eb;">' +
  '<div style="font-size:13px;color:#6b7280;margin-bottom:6px;"><strong>' + e(T.tel_label) + '</strong> +41 (0)61 539 11 89</div>' +
  (isRoyalMail ? '<div style="font-size:13px;color:#6b7280;margin-bottom:6px;"><strong>UK Freephone:</strong> +44 (0) 800 088 4949</div>' : '') +
  '<div style="font-size:13px;color:#6b7280;margin-bottom:6px;"><a href="mailto:help@nutrioplongevity.com" style="color:#6b7280;text-decoration:none;">help@nutrioplongevity.com</a></div>' +
  '<div style="font-size:13px;margin-bottom:14px;"><a href="https://www.nutriop.com" style="color:#FF6B6B;text-decoration:none;font-weight:600;">www.nutriop.com</a></div>' +
  '<div style="font-size:11px;color:#9ca3af;line-height:1.5;">Nutriop Longevity GmbH &bull; Buchenstrasse 59, 4142 M&uuml;nchenstein, Switzerland</div>' +
'</div>' +

'</div></body></html>';
    }

    function renderPreview(){
      var d = getFormData();
      var T = TRANSLATIONS[d.language] || TRANSLATIONS['en'];
      var subject = fillTemplate(T.subject, { order: d.orderNumber || '-' });
      $('preview-subject').textContent = subject;
      var html = buildEmailHtml(d, d.language);
      var frame = $('preview-frame');
      var doc = frame.contentDocument || frame.contentWindow.document;
      doc.open();
      doc.write(html);
      doc.close();
      // Resize iframe to content height after a tick
      setTimeout(function(){
        try {
          var h = doc.documentElement.scrollHeight;
          frame.style.height = Math.min(h, 1400) + 'px';
        } catch(e){}
      }, 30);

      // Origin badge
      var badge = $('origin-badge');
      if(d.originCarrier === 'Swiss Post'){
        badge.innerHTML = '<span class="badge-origin badge-ch">CH - Swiss Post</span>';
      } else if(d.originCarrier === 'Deutsche Post'){
        badge.innerHTML = '<span class="badge-origin badge-de">DE - Deutsche Post</span>';
      } else if(isCourier(d.originCarrier)){
        badge.innerHTML = '<span class="badge-origin badge-courier">' + escapeHtml(d.originCarrier) + '</span>';
      } else if(d.originCarrier){
        badge.innerHTML = '<span class="badge-origin badge-de">' + escapeHtml(d.originCarrier) + '</span>';
      } else {
        badge.innerHTML = '';
      }

      // Language badge
      var langBadge = $('lang-badge');
      if(langBadge){
        var langDisplay = '';
        for(var i=0; i<LANGUAGE_OPTIONS.length; i++){
          if(LANGUAGE_OPTIONS[i][0] === d.language){
            langDisplay = LANGUAGE_OPTIONS[i][1];
            break;
          }
        }
        langBadge.innerHTML = langDisplay ? '<span class="badge-lang">' + escapeHtml(langDisplay) + '</span>' : '';
      }
    }

    /* =========================================================
       VALIDATION + SEND
       ========================================================= */
    function showStatus(type, msg){
      var el = $('status');
      el.className = 'status is-active ' + (type === 'ok' ? 'is-ok' : 'is-err');
      el.innerHTML = '<span class="x" onclick="document.getElementById(\'status\').className=\'status\'">&times;</span>' + msg;
      window.scrollTo({ top:0, behavior:'smooth' });
    }

    function validate(d){
      var errs = [];
      if(!d.firstName)          errs.push('Customer first name');
      if(!d.customerEmail || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(d.customerEmail)) errs.push('Valid customer email');
      if(!d.orderNumber)        errs.push('Order number');
      if(!d.originCarrier)      errs.push('Origin carrier');
      if(!d.trackingNumber)     errs.push('Tracking number');
      if(!d.originTrackingLink || !/^https?:\/\//i.test(d.originTrackingLink)) errs.push('Valid origin tracking link (starts with https://)');
      if(!d.country)            errs.push($('countryCode').value === '__' ? 'Destination country name' : 'Destination country');
      if(!isDirect(d.originCarrier, d.countryCode)){
        if(!d.localCarrier)       errs.push('Local carrier name');
        if(!d.localTrackingLink || !/^https?:\/\//i.test(d.localTrackingLink))  errs.push('Valid local tracking link (starts with https://)');
      }
      if(!d.repName)            errs.push('Your name (Customer Care rep)');
      if(!d.language || !TRANSLATIONS[d.language]) errs.push('Email language');
      return errs;
    }

    function sendEmail(){
      var d = getFormData();
      var errs = validate(d);
      if(errs.length){
        showStatus('err', '<strong>Please fix the following:</strong><br>&bull; ' + errs.join('<br>&bull; '));
        return;
      }

      var passphrase = sessionStorage.getItem('nutriop_staff_pp');
      if(!passphrase){ lock(); return; }

      var btn = $('send-btn');
      var origLabel = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<span class="spinner"></span>Sending...';

      var payload = Object.assign({}, d, { passphrase: passphrase, force: window.__nutriopForce === true });
      window.__nutriopForce = false;

      fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function(r){ return r.json().then(function(j){ return { status:r.status, body:j }; }); })
      .then(function(res){
        btn.disabled = false;
        btn.innerHTML = origLabel;
        if(res.status === 200 && res.body && res.body.success){
          showStatus('ok',
            '<strong>Sent.</strong> Shipping confirmation for order <code>#' + escapeHtml(d.orderNumber) +
            '</code> was delivered to <code>' + escapeHtml(d.customerEmail) + '</code>.' +
            (res.body.id ? ' &nbsp;<span style="opacity:.7">(ref: ' + escapeHtml(res.body.id) + ')</span>' : '')
          );
          // Clear order-specific fields, keep rep + carrier defaults
          resetForm({ keepRep: true });
        } else if(res.status === 401){
          showStatus('err', 'Passphrase rejected. Re-locking the tool.');
          setTimeout(lock, 1500);
        } else {
          if(res.status === 409 && res.body && res.body.code === 'already_sent'){
            showStatus('err', '<strong>Already sent automatically.</strong> ' + escapeHtml(res.body.error) +
              '<br><button type="button" onclick="window.__nutriopForceSend()" style="margin-top:10px;padding:8px 14px;border:0;border-radius:6px;background:#FF6B6B;color:#fff;font-weight:600;cursor:pointer;font-family:inherit;">Send anyway</button>');
            return;
          }
          var detail = (res.body && res.body.error) ? res.body.error : ('HTTP ' + res.status);
          var extra = (res.body && res.body.details) ? '<br><span style="opacity:.7;font-size:12px">' + escapeHtml(JSON.stringify(res.body.details)) + '</span>' : '';
          showStatus('err', '<strong>Send failed.</strong> ' + escapeHtml(detail) + extra);
        }
      })
      .catch(function(err){
        btn.disabled = false;
        btn.innerHTML = origLabel;
        showStatus('err', '<strong>Network error.</strong> ' + escapeHtml(err && err.message ? err.message : String(err)));
      });
    }

    function resetForm(opts){
      opts = opts || {};
      ['firstName','customerEmail','orderNumber','trackingNumber',
       'originTrackingLink','localCarrier','localTrackingLink'].forEach(function(id){
        $(id).value = '';
        delete $(id).dataset.userEdited;
      });
      $('countryCode').value = '';
      $('manualCountryName').value = '';
      if($('postalCode')){ $('postalCode').value = ''; }
      toggleManualCountry();
      $('languageCode').value = 'en';
      delete $('languageCode').dataset.userEdited;
      if(!opts.keepRep){ /* keep repName always - it's their device */ }
      renderPreview();
      $('firstName').focus();
    }

  })();